var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useApiClient } from './useApiClient';
import useSwr from 'swr';
/**
 * GET: Retrieves the metadata for send temporary password endpoint
 * @summary tenants/{tenant}/accounts/sendTemporaryPasswordMetadata
 */
export var getTenantAccountsSendTemporaryPasswordMetadata = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/accounts/sendTemporaryPasswordMetadata"), method: 'get' }, options);
};
export var getGetTenantAccountsSendTemporaryPasswordMetadataKey = function (tenant) {
    return ["/tenants/".concat(tenant, "/accounts/sendTemporaryPasswordMetadata")];
};
/**
 * @summary tenants/{tenant}/accounts/sendTemporaryPasswordMetadata
 */
export var useGetTenantAccountsSendTemporaryPasswordMetadata = function (tenant, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantAccountsSendTemporaryPasswordMetadataKey(tenant) : null); });
    var swrFn = function () {
        return getTenantAccountsSendTemporaryPasswordMetadata(customInstance, tenant, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Configuration for Activation application
 * @summary tenants/{tenant}/applications/activation/configuration
 */
export var getTenantApplicationsActivationConfiguration = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/activation/configuration"), method: 'get' }, options);
};
export var getGetTenantApplicationsActivationConfigurationKey = function (tenant) {
    return ["/tenants/".concat(tenant, "/applications/activation/configuration")];
};
/**
 * @summary tenants/{tenant}/applications/activation/configuration
 */
export var useGetTenantApplicationsActivationConfiguration = function (tenant, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantApplicationsActivationConfigurationKey(tenant) : null); });
    var swrFn = function () {
        return getTenantApplicationsActivationConfiguration(customInstance, tenant, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Localization for AddressForm application
 * @summary tenants/{tenant}/applications/addressForm/localization
 */
export var getTenantApplicationsAddressFormLocalization = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/addressForm/localization"), method: 'get' }, options);
};
export var getGetTenantApplicationsAddressFormLocalizationKey = function (tenant) {
    return ["/tenants/".concat(tenant, "/applications/addressForm/localization")];
};
/**
 * @summary tenants/{tenant}/applications/addressForm/localization
 */
export var useGetTenantApplicationsAddressFormLocalization = function (tenant, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantApplicationsAddressFormLocalizationKey(tenant) : null); });
    var swrFn = function () {
        return getTenantApplicationsAddressFormLocalization(customInstance, tenant, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Returns options for address formatting
 * @summary tenants/{tenant}/addressFormats
 */
export var getTenantAddressFormats = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/addressFormats"), method: 'get' }, options);
};
export var getGetTenantAddressFormatsKey = function (tenant) {
    return ["/tenants/".concat(tenant, "/addressFormats")];
};
/**
 * @summary tenants/{tenant}/addressFormats
 */
export var useGetTenantAddressFormats = function (tenant, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantAddressFormatsKey(tenant) : null); });
    var swrFn = function () {
        return getTenantAddressFormats(customInstance, tenant, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Returns specific option for address formatting
 * @summary tenants/{tenant}/addressFormats/{type}
 */
export var getTenantAddressFormat = function (client, tenant, type, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/addressFormats/").concat(type), method: 'get' }, options);
};
export var getGetTenantAddressFormatKey = function (tenant, type) { return ["/tenants/".concat(tenant, "/addressFormats/").concat(type)]; };
/**
 * @summary tenants/{tenant}/addressFormats/{type}
 */
export var useGetTenantAddressFormat = function (tenant, type, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(tenant && type);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantAddressFormatKey(tenant, type) : null); });
    var swrFn = function () {
        return getTenantAddressFormat(customInstance, tenant, type, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Localization for Adverse Reaction SPA
 * @summary tenants/{tenant}/applications/adverseReaction/localization
 */
export var getTenantApplicationsAdverseReactionLocalization = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/adverseReaction/localization"), method: 'get' }, options);
};
export var getGetTenantApplicationsAdverseReactionLocalizationKey = function (tenant) {
    return ["/tenants/".concat(tenant, "/applications/adverseReaction/localization")];
};
/**
 * @summary tenants/{tenant}/applications/adverseReaction/localization
 */
export var useGetTenantApplicationsAdverseReactionLocalization = function (tenant, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantApplicationsAdverseReactionLocalizationKey(tenant) : null); });
    var swrFn = function () {
        return getTenantApplicationsAdverseReactionLocalization(customInstance, tenant, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Get partial set of products - returned limited number of products.
 * @summary tenants/{tenant}/applications/adverseReaction/productsPartialSet
 */
export var getTenantApplicationsAdverseReactionProductsPartialSet = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/adverseReaction/productsPartialSet"),
        method: 'get',
        params: params,
    }, options);
};
export var getGetTenantApplicationsAdverseReactionProductsPartialSetKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/adverseReaction/productsPartialSet")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/adverseReaction/productsPartialSet
 */
export var useGetTenantApplicationsAdverseReactionProductsPartialSet = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetTenantApplicationsAdverseReactionProductsPartialSetKey(tenant, params)
            : null;
    });
    var swrFn = function () {
        return getTenantApplicationsAdverseReactionProductsPartialSet(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Provides app link
 * @summary tenants/{tenant}/appLinkTypes/{appLinkType}/appLink
 */
export var getTenantAppLinkTypeAppLink = function (client, tenant, appLinkType, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/appLinkTypes/").concat(appLinkType, "/appLink"), method: 'get', params: params }, options);
};
export var getGetTenantAppLinkTypeAppLinkKey = function (tenant, appLinkType, params) {
    return __spreadArray(["/tenants/".concat(tenant, "/appLinkTypes/").concat(appLinkType, "/appLink")], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/appLinkTypes/{appLinkType}/appLink
 */
export var useGetTenantAppLinkTypeAppLink = function (tenant, appLinkType, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(tenant && appLinkType);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantAppLinkTypeAppLinkKey(tenant, appLinkType, params) : null); });
    var swrFn = function () {
        return getTenantAppLinkTypeAppLink(customInstance, tenant, appLinkType, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets ATP cluster
 * @summary tenants/{tenant}/atpClusters/{atpClusterId}
 */
export var getTenantAtpCluster = function (client, tenant, atpClusterId, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/atpClusters/").concat(atpClusterId), method: 'get' }, options);
};
export var getGetTenantAtpClusterKey = function (tenant, atpClusterId) {
    return ["/tenants/".concat(tenant, "/atpClusters/").concat(atpClusterId)];
};
/**
 * @summary tenants/{tenant}/atpClusters/{atpClusterId}
 */
export var useGetTenantAtpCluster = function (tenant, atpClusterId, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(tenant && atpClusterId);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantAtpClusterKey(tenant, atpClusterId) : null); });
    var swrFn = function () {
        return getTenantAtpCluster(customInstance, tenant, atpClusterId, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Find ATP cluster based on delivery channel and/or delivery address
 * @summary tenants/{tenant}/atpClusters
 */
export var getTenantAtpClusters = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/atpClusters"), method: 'get', params: params }, options);
};
export var getGetTenantAtpClustersKey = function (tenant, params) {
    return __spreadArray(["/tenants/".concat(tenant, "/atpClusters")], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/atpClusters
 */
export var useGetTenantAtpClusters = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantAtpClustersKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantAtpClusters(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get availability of product
 * @summary tenants/{tenant}/products/{productCode}/availability
 */
export var getTenantProductAvailability = function (client, tenant, productCode, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/products/").concat(productCode, "/availability"), method: 'get', params: params }, options);
};
export var getGetTenantProductAvailabilityKey = function (tenant, productCode, params) {
    return __spreadArray(["/tenants/".concat(tenant, "/products/").concat(productCode, "/availability")], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/products/{productCode}/availability
 */
export var useGetTenantProductAvailability = function (tenant, productCode, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(tenant && productCode);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantProductAvailabilityKey(tenant, productCode, params) : null); });
    var swrFn = function () {
        return getTenantProductAvailability(customInstance, tenant, productCode, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get availability of products
 * @summary tenants/{tenant}/productsAvailability
 */
export var getTenantProductsAvailability = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/productsAvailability"), method: 'get', params: params }, options);
};
export var getGetTenantProductsAvailabilityKey = function (tenant, params) { return __spreadArray(["/tenants/".concat(tenant, "/productsAvailability")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/productsAvailability
 */
export var useGetTenantProductsAvailability = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantProductsAvailabilityKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantProductsAvailability(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Provides information about concept availability
 * @summary tenants/{tenant}/concepts/{conceptCode}/availability
 */
export var getTenantConceptAvailability = function (client, tenant, conceptCode, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/concepts/").concat(conceptCode, "/availability"), method: 'get', params: params }, options);
};
export var getGetTenantConceptAvailabilityKey = function (tenant, conceptCode, params) {
    return __spreadArray(["/tenants/".concat(tenant, "/concepts/").concat(conceptCode, "/availability")], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/concepts/{conceptCode}/availability
 */
export var useGetTenantConceptAvailability = function (tenant, conceptCode, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(tenant && conceptCode);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantConceptAvailabilityKey(tenant, conceptCode, params) : null); });
    var swrFn = function () {
        return getTenantConceptAvailability(customInstance, tenant, conceptCode, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET - returns back in stock notification availability for each of requested products.
 * @summary tenants/{tenant}/backInStockNotifications
 */
export var getTenantBackInStockNotifications = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/backInStockNotifications"), method: 'get', params: params }, options);
};
export var getGetTenantBackInStockNotificationsKey = function (tenant, params) { return __spreadArray(["/tenants/".concat(tenant, "/backInStockNotifications")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/backInStockNotifications
 */
export var useGetTenantBackInStockNotifications = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantBackInStockNotificationsKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantBackInStockNotifications(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET - returns Configuration properties for BackInStock Notifications.
 * @summary tenants/{tenant}/backInStockNotificationsConfiguration
 */
export var getTenantBackInStockNotificationsConfiguration = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/backInStockNotificationsConfiguration"), method: 'get', params: params }, options);
};
export var getGetTenantBackInStockNotificationsConfigurationKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/backInStockNotificationsConfiguration")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/backInStockNotificationsConfiguration
 */
export var useGetTenantBackInStockNotificationsConfiguration = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetTenantBackInStockNotificationsConfigurationKey(tenant, params) : null;
    });
    var swrFn = function () {
        return getTenantBackInStockNotificationsConfiguration(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET - Bazaar Voice Api Controller
 * @summary tenants/{tenant}/bazaarvoice/configuration
 */
export var getTenantBazaarvoiceConfiguration = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/bazaarvoice/configuration"), method: 'get', params: params }, options);
};
export var getGetTenantBazaarvoiceConfigurationKey = function (tenant, params) { return __spreadArray(["/tenants/".concat(tenant, "/bazaarvoice/configuration")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/bazaarvoice/configuration
 */
export var useGetTenantBazaarvoiceConfiguration = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantBazaarvoiceConfigurationKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantBazaarvoiceConfiguration(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get beauty reward points localization
 * @summary beautyRewardPoints/tenants/{tenant}/localization
 */
export var getBeautyRewardPointsTenantLocalization = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/beautyRewardPoints/tenants/".concat(tenant, "/localization"), method: 'get', params: params }, options);
};
export var getGetBeautyRewardPointsTenantLocalizationKey = function (tenant, params) { return __spreadArray(["/beautyRewardPoints/tenants/".concat(tenant, "/localization")], (params ? [params] : []), true); };
/**
 * @summary beautyRewardPoints/tenants/{tenant}/localization
 */
export var useGetBeautyRewardPointsTenantLocalization = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetBeautyRewardPointsTenantLocalizationKey(tenant, params) : null); });
    var swrFn = function () {
        return getBeautyRewardPointsTenantLocalization(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get all brands, optionally filtered by given category
 * @summary tenants/{tenant}/brands
 */
export var getTenantBrands = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/brands"), method: 'get', params: params }, options);
};
export var getGetTenantBrandsKey = function (tenant, params) {
    return __spreadArray(["/tenants/".concat(tenant, "/brands")], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/brands
 */
export var useGetTenantBrands = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantBrandsKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantBrands(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets brand by brand id
 * @summary tenants/{tenant}/brands/{brandId}
 */
export var getTenantBrand = function (client, tenant, brandId, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/brands/").concat(brandId), method: 'get', params: params }, options);
};
export var getGetTenantBrandKey = function (tenant, brandId, params) { return __spreadArray(["/tenants/".concat(tenant, "/brands/").concat(brandId)], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/brands/{brandId}
 */
export var useGetTenantBrand = function (tenant, brandId, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(tenant && brandId);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantBrandKey(tenant, brandId, params) : null); });
    var swrFn = function () {
        return getTenantBrand(customInstance, tenant, brandId, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Provides link to a single brand.
 * @summary tenants/{tenant}/brands/{brandId}/dynamiclink
 */
export var getTenantBrandDynamiclink = function (client, tenant, brandId, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/brands/").concat(brandId, "/dynamiclink"), method: 'get', params: params }, options);
};
export var getGetTenantBrandDynamiclinkKey = function (tenant, brandId, params) { return __spreadArray(["/tenants/".concat(tenant, "/brands/").concat(brandId, "/dynamiclink")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/brands/{brandId}/dynamiclink
 */
export var useGetTenantBrandDynamiclink = function (tenant, brandId, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(tenant && brandId);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantBrandDynamiclinkKey(tenant, brandId, params) : null); });
    var swrFn = function () {
        return getTenantBrandDynamiclink(customInstance, tenant, brandId, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets the brand listing data for Mv7 mobile app.
 * @deprecated
 * @summary tenants/{tenant}/applications/mv7/brandProductListing
 */
export var getTenantApplicationsMv7BrandProductListing = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/mv7/brandProductListing"), method: 'get', params: params }, options);
};
export var getGetTenantApplicationsMv7BrandProductListingKey = function (tenant, params) {
    return __spreadArray(["/tenants/".concat(tenant, "/applications/mv7/brandProductListing")], (params ? [params] : []), true);
};
/**
 * @deprecated
 * @summary tenants/{tenant}/applications/mv7/brandProductListing
 */
export var useGetTenantApplicationsMv7BrandProductListing = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantApplicationsMv7BrandProductListingKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantApplicationsMv7BrandProductListing(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get Breadcrumbs links.
 * @summary tenants/{tenant}/applications/breadcrumb/links
 */
export var getTenantApplicationsBreadcrumbLinks = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/breadcrumb/links"), method: 'get', params: params }, options);
};
export var getGetTenantApplicationsBreadcrumbLinksKey = function (tenant, params) { return __spreadArray(["/tenants/".concat(tenant, "/applications/breadcrumb/links")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/applications/breadcrumb/links
 */
export var useGetTenantApplicationsBreadcrumbLinks = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantApplicationsBreadcrumbLinksKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantApplicationsBreadcrumbLinks(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Returns BCM incentives configuration (images, youtube ID...)
 * @summary tenants/{tenant}/businessModels/bcm/incentivesConfiguration
 */
export var getTenantBusinessModelsBcmIncentivesConfiguration = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/businessModels/bcm/incentivesConfiguration"), method: 'get' }, options);
};
export var getGetTenantBusinessModelsBcmIncentivesConfigurationKey = function (tenant) {
    return ["/tenants/".concat(tenant, "/businessModels/bcm/incentivesConfiguration")];
};
/**
 * @summary tenants/{tenant}/businessModels/bcm/incentivesConfiguration
 */
export var useGetTenantBusinessModelsBcmIncentivesConfiguration = function (tenant, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantBusinessModelsBcmIncentivesConfigurationKey(tenant) : null); });
    var swrFn = function () {
        return getTenantBusinessModelsBcmIncentivesConfiguration(customInstance, tenant, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get Rewards Shop configurations
 * @summary tenants/{tenant}/rewardShopConfigurations
 */
export var getTenantRewardShopConfigurations = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/rewardShopConfigurations"), method: 'get', params: params }, options);
};
export var getGetTenantRewardShopConfigurationsKey = function (tenant, params) { return __spreadArray(["/tenants/".concat(tenant, "/rewardShopConfigurations")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/rewardShopConfigurations
 */
export var useGetTenantRewardShopConfigurations = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantRewardShopConfigurationsKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantRewardShopConfigurations(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET - returns configuration for Catalogue IPaper
 * @summary tenants/{tenant}/applications/catalogueIPaper/configuration
 */
export var getTenantApplicationsCatalogueIPaperConfiguration = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/catalogueIPaper/configuration"), method: 'get', params: params }, options);
};
export var getGetTenantApplicationsCatalogueIPaperConfigurationKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/catalogueIPaper/configuration")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/catalogueIPaper/configuration
 */
export var useGetTenantApplicationsCatalogueIPaperConfiguration = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetTenantApplicationsCatalogueIPaperConfigurationKey(tenant, params) : null;
    });
    var swrFn = function () {
        return getTenantApplicationsCatalogueIPaperConfiguration(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET - returns collection of available catalogues for iPaper platform.
 * @summary tenants/{tenant}/applications/catalogueOverview
 */
export var getTenantApplicationsCatalogueOverview = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/catalogueOverview"), method: 'get', params: params }, options);
};
export var getGetTenantApplicationsCatalogueOverviewKey = function (tenant, params) { return __spreadArray(["/tenants/".concat(tenant, "/applications/catalogueOverview")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/applications/catalogueOverview
 */
export var useGetTenantApplicationsCatalogueOverview = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantApplicationsCatalogueOverviewKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantApplicationsCatalogueOverview(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Provide catalogues related to the period
 * @summary tenants/{tenant}/catalogues
 */
export var getTenantCatalogues = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/catalogues"), method: 'get', params: params }, options);
};
export var getGetTenantCataloguesKey = function (tenant, params) {
    return __spreadArray(["/tenants/".concat(tenant, "/catalogues")], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/catalogues
 */
export var useGetTenantCatalogues = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantCataloguesKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantCatalogues(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Provides link to the current digital catalogue.
 * @summary tenants/{tenant}/catalogues/{catalogueId}/dynamiclink
 */
export var getTenantCatalogueDynamiclink = function (client, tenant, catalogueId, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/catalogues/").concat(catalogueId, "/dynamiclink"), method: 'get', params: params }, options);
};
export var getGetTenantCatalogueDynamiclinkKey = function (tenant, catalogueId, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/catalogues/").concat(catalogueId, "/dynamiclink")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/catalogues/{catalogueId}/dynamiclink
 */
export var useGetTenantCatalogueDynamiclink = function (tenant, catalogueId, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(tenant && catalogueId);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantCatalogueDynamiclinkKey(tenant, catalogueId, params) : null); });
    var swrFn = function () {
        return getTenantCatalogueDynamiclink(customInstance, tenant, catalogueId, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Provides link to the current digital catalogue.
 * @summary tenants/{tenant}/digitalCatalogue/dynamiclink
 */
export var getTenantDigitalCatalogueDynamiclink = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/digitalCatalogue/dynamiclink"), method: 'get', params: params }, options);
};
export var getGetTenantDigitalCatalogueDynamiclinkKey = function (tenant, params) { return __spreadArray(["/tenants/".concat(tenant, "/digitalCatalogue/dynamiclink")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/digitalCatalogue/dynamiclink
 */
export var useGetTenantDigitalCatalogueDynamiclink = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantDigitalCatalogueDynamiclinkKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantDigitalCatalogueDynamiclink(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get all categories
 * @summary tenants/{tenant}/categories
 */
export var getTenantCategories = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/categories"), method: 'get', params: params }, options);
};
export var getGetTenantCategoriesKey = function (tenant, params) {
    return __spreadArray(["/tenants/".concat(tenant, "/categories")], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/categories
 */
export var useGetTenantCategories = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantCategoriesKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantCategories(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Provides category dynamic link.
 * @summary tenants/{tenant}/categories/{categoryId}/dynamiclink
 */
export var getTenantCategoryDynamiclink = function (client, tenant, categoryId, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/categories/").concat(categoryId, "/dynamiclink"), method: 'get', params: params }, options);
};
export var getGetTenantCategoryDynamiclinkKey = function (tenant, categoryId, params) {
    return __spreadArray(["/tenants/".concat(tenant, "/categories/").concat(categoryId, "/dynamiclink")], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/categories/{categoryId}/dynamiclink
 */
export var useGetTenantCategoryDynamiclink = function (tenant, categoryId, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(tenant && categoryId);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantCategoryDynamiclinkKey(tenant, categoryId, params) : null); });
    var swrFn = function () {
        return getTenantCategoryDynamiclink(customInstance, tenant, categoryId, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets the category listing data for Mv7 mobile app.
 * @deprecated
 * @summary tenants/{tenant}/applications/mv7/categoryProductListing
 */
export var getTenantApplicationsMv7CategoryProductListing = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/mv7/categoryProductListing"), method: 'get', params: params }, options);
};
export var getGetTenantApplicationsMv7CategoryProductListingKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/mv7/categoryProductListing")
    ], (params ? [params] : []), true);
};
/**
 * @deprecated
 * @summary tenants/{tenant}/applications/mv7/categoryProductListing
 */
export var useGetTenantApplicationsMv7CategoryProductListing = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetTenantApplicationsMv7CategoryProductListingKey(tenant, params) : null;
    });
    var swrFn = function () {
        return getTenantApplicationsMv7CategoryProductListing(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Returns content for CEO page
 * @summary tenants/{tenant}/applications/ceo/content
 */
export var getTenantApplicationsCeoContent = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/ceo/content"), method: 'get' }, options);
};
export var getGetTenantApplicationsCeoContentKey = function (tenant) {
    return ["/tenants/".concat(tenant, "/applications/ceo/content")];
};
/**
 * @summary tenants/{tenant}/applications/ceo/content
 */
export var useGetTenantApplicationsCeoContent = function (tenant, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantApplicationsCeoContentKey(tenant) : null); });
    var swrFn = function () {
        return getTenantApplicationsCeoContent(customInstance, tenant, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Returns Chat bot metadata
 * @summary tenants/{tenant}/applications/chatBot/metadata
 */
export var getTenantApplicationsChatBotMetadata = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/chatBot/metadata"), method: 'get' }, options);
};
export var getGetTenantApplicationsChatBotMetadataKey = function (tenant) {
    return ["/tenants/".concat(tenant, "/applications/chatBot/metadata")];
};
/**
 * @summary tenants/{tenant}/applications/chatBot/metadata
 */
export var useGetTenantApplicationsChatBotMetadata = function (tenant, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantApplicationsChatBotMetadataKey(tenant) : null); });
    var swrFn = function () {
        return getTenantApplicationsChatBotMetadata(customInstance, tenant, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Returns Chat bot page metadata
 * @summary tenants/{tenant}/applications/chatBot/pageMetadata
 */
export var getTenantApplicationsChatBotPageMetadata = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/chatBot/pageMetadata"), method: 'get', params: params }, options);
};
export var getGetTenantApplicationsChatBotPageMetadataKey = function (tenant, params) { return __spreadArray(["/tenants/".concat(tenant, "/applications/chatBot/pageMetadata")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/applications/chatBot/pageMetadata
 */
export var useGetTenantApplicationsChatBotPageMetadata = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantApplicationsChatBotPageMetadataKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantApplicationsChatBotPageMetadata(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Configuration for Simplified Checkout ASMS
 * @summary tenants/{tenant}/applications/shoppingBag/configuration
 */
export var getTenantApplicationsShoppingBagConfiguration = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/shoppingBag/configuration"), method: 'get' }, options);
};
export var getGetTenantApplicationsShoppingBagConfigurationKey = function (tenant) {
    return ["/tenants/".concat(tenant, "/applications/shoppingBag/configuration")];
};
/**
 * @summary tenants/{tenant}/applications/shoppingBag/configuration
 */
export var useGetTenantApplicationsShoppingBagConfiguration = function (tenant, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantApplicationsShoppingBagConfigurationKey(tenant) : null); });
    var swrFn = function () {
        return getTenantApplicationsShoppingBagConfiguration(customInstance, tenant, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Content for Checkout registration application
 * @summary tenants/{tenant}/applications/checkoutRegistration/content
 */
export var getTenantApplicationsCheckoutRegistrationContent = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/checkoutRegistration/content"), method: 'get', params: params }, options);
};
export var getGetTenantApplicationsCheckoutRegistrationContentKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/checkoutRegistration/content")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/checkoutRegistration/content
 */
export var useGetTenantApplicationsCheckoutRegistrationContent = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetTenantApplicationsCheckoutRegistrationContentKey(tenant, params) : null;
    });
    var swrFn = function () {
        return getTenantApplicationsCheckoutRegistrationContent(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Provides information about commission plan type for the market in the specified period. If the period is not specified, the current period is used.
 * @summary tenants/{tenant}/commissionPlanType
 */
export var getTenantCommissionPlanType = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/commissionPlanType"), method: 'get', params: params }, options);
};
export var getGetTenantCommissionPlanTypeKey = function (tenant, params) { return __spreadArray(["/tenants/".concat(tenant, "/commissionPlanType")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/commissionPlanType
 */
export var useGetTenantCommissionPlanType = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantCommissionPlanTypeKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantCommissionPlanType(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets calculated attributes for concepts from product index.
 * @summary tenants/{tenant}/conceptIndexItems
 */
export var getTenantConceptIndexItems = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/conceptIndexItems"), method: 'get', params: params }, options);
};
export var getGetTenantConceptIndexItemsKey = function (tenant, params) { return __spreadArray(["/tenants/".concat(tenant, "/conceptIndexItems")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/conceptIndexItems
 */
export var useGetTenantConceptIndexItems = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantConceptIndexItemsKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantConceptIndexItems(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets collection of concept labels for anonymous customer.
 * @summary tenants/{tenant}/conceptLabels
 */
export var getTenantConceptLabels = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/conceptLabels"), method: 'get', params: params }, options);
};
export var getGetTenantConceptLabelsKey = function (tenant, params) { return __spreadArray(["/tenants/".concat(tenant, "/conceptLabels")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/conceptLabels
 */
export var useGetTenantConceptLabels = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantConceptLabelsKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantConceptLabels(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Provides concept
 * @summary tenants/{tenant}/deprecatedConcepts/{conceptCode}
 */
export var getTenantDeprecatedConcept = function (client, tenant, conceptCode, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/deprecatedConcepts/").concat(conceptCode), method: 'get', params: params }, options);
};
export var getGetTenantDeprecatedConceptKey = function (tenant, conceptCode, params) { return __spreadArray(["/tenants/".concat(tenant, "/deprecatedConcepts/").concat(conceptCode)], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/deprecatedConcepts/{conceptCode}
 */
export var useGetTenantDeprecatedConcept = function (tenant, conceptCode, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(tenant && conceptCode);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantDeprecatedConceptKey(tenant, conceptCode, params) : null); });
    var swrFn = function () {
        return getTenantDeprecatedConcept(customInstance, tenant, conceptCode, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Provides concept
 * @summary tenants/{tenant}/concepts/{conceptCode}
 */
export var getTenantConcept = function (client, tenant, conceptCode, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/concepts/").concat(conceptCode), method: 'get', params: params }, options);
};
export var getGetTenantConceptKey = function (tenant, conceptCode, params) { return __spreadArray(["/tenants/".concat(tenant, "/concepts/").concat(conceptCode)], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/concepts/{conceptCode}
 */
export var useGetTenantConcept = function (tenant, conceptCode, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(tenant && conceptCode);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantConceptKey(tenant, conceptCode, params) : null); });
    var swrFn = function () {
        return getTenantConcept(customInstance, tenant, conceptCode, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets the concepts data for Mv7 mobile app.
 * @summary tenants/{tenant}/applications/mv7/modules/conceptsRepository/concepts
 */
export var getTenantApplicationsMv7ModulesConceptsRepositoryConcepts = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/mv7/modules/conceptsRepository/concepts"),
        method: 'get',
        params: params,
    }, options);
};
export var getGetTenantApplicationsMv7ModulesConceptsRepositoryConceptsKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/mv7/modules/conceptsRepository/concepts")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/mv7/modules/conceptsRepository/concepts
 */
export var useGetTenantApplicationsMv7ModulesConceptsRepositoryConcepts = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetTenantApplicationsMv7ModulesConceptsRepositoryConceptsKey(tenant, params)
            : null;
    });
    var swrFn = function () {
        return getTenantApplicationsMv7ModulesConceptsRepositoryConcepts(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets the concepts hash codes data for Mv7 mobile app.
 * @summary tenants/{tenant}/applications/mv7/modules/conceptsRepository/conceptsHashCodes
 */
export var getTenantApplicationsMv7ModulesConceptsRepositoryConceptsHashCodes = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/mv7/modules/conceptsRepository/conceptsHashCodes"),
        method: 'get',
        params: params,
    }, options);
};
export var getGetTenantApplicationsMv7ModulesConceptsRepositoryConceptsHashCodesKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/mv7/modules/conceptsRepository/conceptsHashCodes")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/mv7/modules/conceptsRepository/conceptsHashCodes
 */
export var useGetTenantApplicationsMv7ModulesConceptsRepositoryConceptsHashCodes = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetTenantApplicationsMv7ModulesConceptsRepositoryConceptsHashCodesKey(tenant, params)
            : null;
    });
    var swrFn = function () {
        return getTenantApplicationsMv7ModulesConceptsRepositoryConceptsHashCodes(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets the concepts labels data for Mv7 mobile app.
 * @summary tenants/{tenant}/applications/mv7/modules/conceptsLabelsRepository/conceptsLabels
 */
export var getTenantApplicationsMv7ModulesConceptsLabelsRepositoryConceptsLabels = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/mv7/modules/conceptsLabelsRepository/conceptsLabels"),
        method: 'get',
        params: params,
    }, options);
};
export var getGetTenantApplicationsMv7ModulesConceptsLabelsRepositoryConceptsLabelsKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/mv7/modules/conceptsLabelsRepository/conceptsLabels")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/mv7/modules/conceptsLabelsRepository/conceptsLabels
 */
export var useGetTenantApplicationsMv7ModulesConceptsLabelsRepositoryConceptsLabels = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetTenantApplicationsMv7ModulesConceptsLabelsRepositoryConceptsLabelsKey(tenant, params)
            : null;
    });
    var swrFn = function () {
        return getTenantApplicationsMv7ModulesConceptsLabelsRepositoryConceptsLabels(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Returns 10 recommended concept for certain concept, based on behavioral similarity of the users or content similiarity of products.
 * @summary tenants/{tenant}/concepts/{conceptCode}/recommendations
 */
export var getTenantConceptRecommendations = function (client, tenant, conceptCode, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/concepts/").concat(conceptCode, "/recommendations"), method: 'get', params: params }, options);
};
export var getGetTenantConceptRecommendationsKey = function (tenant, conceptCode, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/concepts/").concat(conceptCode, "/recommendations")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/concepts/{conceptCode}/recommendations
 */
export var useGetTenantConceptRecommendations = function (tenant, conceptCode, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(tenant && conceptCode);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantConceptRecommendationsKey(tenant, conceptCode, params) : null); });
    var swrFn = function () {
        return getTenantConceptRecommendations(customInstance, tenant, conceptCode, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Returns 20 recommended conceptw for certain concept list
 * @summary tenants/{tenant}/conceptRecommendations
 */
export var getTenantFilteredConceptRecommendations = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/conceptRecommendations"), method: 'get', params: params }, options);
};
export var getGetTenantFilteredConceptRecommendationsKey = function (tenant, params) { return __spreadArray(["/tenants/".concat(tenant, "/conceptRecommendations")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/conceptRecommendations
 */
export var useGetTenantFilteredConceptRecommendations = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantFilteredConceptRecommendationsKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantFilteredConceptRecommendations(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Returns recommended bestseller concepts
 * @summary tenants/{tenant}/bestsellers
 */
export var getTenantBestsellers = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/bestsellers"), method: 'get', params: params }, options);
};
export var getGetTenantBestsellersKey = function (tenant, params) {
    return __spreadArray(["/tenants/".concat(tenant, "/bestsellers")], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/bestsellers
 */
export var useGetTenantBestsellers = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantBestsellersKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantBestsellers(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET - returns Concern Report Form localization labels.
 * @summary tenants/{tenant}/applications/concernReportForm/localization
 */
export var getTenantApplicationsConcernReportFormLocalization = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/concernReportForm/localization"),
        method: 'get',
        params: params,
    }, options);
};
export var getGetTenantApplicationsConcernReportFormLocalizationKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/concernReportForm/localization")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/concernReportForm/localization
 */
export var useGetTenantApplicationsConcernReportFormLocalization = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetTenantApplicationsConcernReportFormLocalizationKey(tenant, params) : null;
    });
    var swrFn = function () {
        return getTenantApplicationsConcernReportFormLocalization(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET - returns configuration for Concern Report Form
 * @summary tenants/{tenant}/applications/concernReportForm/configuration
 */
export var getTenantApplicationsConcernReportFormConfiguration = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/concernReportForm/configuration"),
        method: 'get',
        params: params,
    }, options);
};
export var getGetTenantApplicationsConcernReportFormConfigurationKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/concernReportForm/configuration")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/concernReportForm/configuration
 */
export var useGetTenantApplicationsConcernReportFormConfiguration = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetTenantApplicationsConcernReportFormConfigurationKey(tenant, params) : null;
    });
    var swrFn = function () {
        return getTenantApplicationsConcernReportFormConfiguration(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get consultant info localization
 * @summary consultantInfo/tenants/{tenant}/localization
 */
export var getConsultantInfoTenantLocalization = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/consultantInfo/tenants/".concat(tenant, "/localization"), method: 'get', params: params }, options);
};
export var getGetConsultantInfoTenantLocalizationKey = function (tenant, params) { return __spreadArray(["/consultantInfo/tenants/".concat(tenant, "/localization")], (params ? [params] : []), true); };
/**
 * @summary consultantInfo/tenants/{tenant}/localization
 */
export var useGetConsultantInfoTenantLocalization = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetConsultantInfoTenantLocalizationKey(tenant, params) : null); });
    var swrFn = function () {
        return getConsultantInfoTenantLocalization(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets the consultant titles localization.
 * @summary tenants/{tenant}/applications/businessapp/consultantTitlesLocalization
 */
export var getTenantApplicationsBusinessappConsultantTitlesLocalization = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/businessapp/consultantTitlesLocalization"),
        method: 'get',
        params: params,
    }, options);
};
export var getGetTenantApplicationsBusinessappConsultantTitlesLocalizationKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/businessapp/consultantTitlesLocalization")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/businessapp/consultantTitlesLocalization
 */
export var useGetTenantApplicationsBusinessappConsultantTitlesLocalization = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetTenantApplicationsBusinessappConsultantTitlesLocalizationKey(tenant, params)
            : null;
    });
    var swrFn = function () {
        return getTenantApplicationsBusinessappConsultantTitlesLocalization(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Returns metadata about contact details of registration with given ID
 * @summary tenants/{tenant}/customerRegistrationsMetadata/{registrationType}/contactDetailsMetadata
 */
export var getTenantCustomerRegistrationsMetadatumContactDetailsMetadata = function (client, tenant, registrationType, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/customerRegistrationsMetadata/").concat(registrationType, "/contactDetailsMetadata"),
        method: 'get',
    }, options);
};
export var getGetTenantCustomerRegistrationsMetadatumContactDetailsMetadataKey = function (tenant, registrationType) {
    return [
        "/tenants/".concat(tenant, "/customerRegistrationsMetadata/").concat(registrationType, "/contactDetailsMetadata"),
    ];
};
/**
 * @summary tenants/{tenant}/customerRegistrationsMetadata/{registrationType}/contactDetailsMetadata
 */
export var useGetTenantCustomerRegistrationsMetadatumContactDetailsMetadata = function (tenant, registrationType, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(tenant && registrationType);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetTenantCustomerRegistrationsMetadatumContactDetailsMetadataKey(tenant, registrationType)
            : null;
    });
    var swrFn = function () {
        return getTenantCustomerRegistrationsMetadatumContactDetailsMetadata(customInstance, tenant, registrationType, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Returns information for all countries on market
 * @summary tenants/{tenant}/countries
 */
export var getTenantCountries = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/countries"), method: 'get', params: params }, options);
};
export var getGetTenantCountriesKey = function (tenant, params) {
    return __spreadArray(["/tenants/".concat(tenant, "/countries")], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/countries
 */
export var useGetTenantCountries = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantCountriesKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantCountries(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Returns information for country with given country code
 * @summary tenants/{tenant}/countries/{countryCode}
 */
export var getTenantCountry = function (client, tenant, countryCode, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/countries/").concat(countryCode), method: 'get', params: params }, options);
};
export var getGetTenantCountryKey = function (tenant, countryCode, params) { return __spreadArray(["/tenants/".concat(tenant, "/countries/").concat(countryCode)], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/countries/{countryCode}
 */
export var useGetTenantCountry = function (tenant, countryCode, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(tenant && countryCode);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantCountryKey(tenant, countryCode, params) : null); });
    var swrFn = function () {
        return getTenantCountry(customInstance, tenant, countryCode, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET - provides tenant culture settings
 * @summary tenants/{tenant}/culture
 */
export var getTenantCulture = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/culture"), method: 'get' }, options);
};
export var getGetTenantCultureKey = function (tenant) { return ["/tenants/".concat(tenant, "/culture")]; };
/**
 * @summary tenants/{tenant}/culture
 */
export var useGetTenantCulture = function (tenant, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantCultureKey(tenant) : null); });
    var swrFn = function () { return getTenantCulture(customInstance, tenant, requestOptions).then(function (d) { return d.data; }); };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Returns metadata for customer confirmation endpoints
 * @summary tenants/{tenant}/customerConfirmationMetadata
 */
export var getTenantCustomerConfirmationMetadata = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/customerConfirmationMetadata"), method: 'get', params: params }, options);
};
export var getGetTenantCustomerConfirmationMetadataKey = function (tenant, params) { return __spreadArray(["/tenants/".concat(tenant, "/customerConfirmationMetadata")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/customerConfirmationMetadata
 */
export var useGetTenantCustomerConfirmationMetadata = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantCustomerConfirmationMetadataKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantCustomerConfirmationMetadata(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Gets the metadata for the customer registration instructions
 * @summary tenants/{tenant}/customerRegistrationInstructionsMetadata
 */
export var getTenantCustomerRegistrationInstructionsMetadata = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/customerRegistrationInstructionsMetadata"), method: 'get' }, options);
};
export var getGetTenantCustomerRegistrationInstructionsMetadataKey = function (tenant) {
    return ["/tenants/".concat(tenant, "/customerRegistrationInstructionsMetadata")];
};
/**
 * @summary tenants/{tenant}/customerRegistrationInstructionsMetadata
 */
export var useGetTenantCustomerRegistrationInstructionsMetadata = function (tenant, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantCustomerRegistrationInstructionsMetadataKey(tenant) : null); });
    var swrFn = function () {
        return getTenantCustomerRegistrationInstructionsMetadata(customInstance, tenant, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets delivery configuration
 * @summary tenants/{tenant}/applications/configuration/delivery
 */
export var getTenantApplicationsConfigurationDelivery = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/configuration/delivery"), method: 'get', params: params }, options);
};
export var getGetTenantApplicationsConfigurationDeliveryKey = function (tenant, params) {
    return __spreadArray(["/tenants/".concat(tenant, "/applications/configuration/delivery")], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/configuration/delivery
 */
export var useGetTenantApplicationsConfigurationDelivery = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantApplicationsConfigurationDeliveryKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantApplicationsConfigurationDelivery(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Provide delivery methods
 * @summary tenants/{tenant}/deliveryMethods
 */
export var getTenantDeliveryMethods = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/deliveryMethods"), method: 'get' }, options);
};
export var getGetTenantDeliveryMethodsKey = function (tenant) {
    return ["/tenants/".concat(tenant, "/deliveryMethods")];
};
/**
 * @summary tenants/{tenant}/deliveryMethods
 */
export var useGetTenantDeliveryMethods = function (tenant, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantDeliveryMethodsKey(tenant) : null); });
    var swrFn = function () {
        return getTenantDeliveryMethods(customInstance, tenant, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets all available document types
 * @summary tenants/{tenant}/documentTypes
 */
export var getTenantDocumentTypes = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/documentTypes"), method: 'get' }, options);
};
export var getGetTenantDocumentTypesKey = function (tenant) {
    return ["/tenants/".concat(tenant, "/documentTypes")];
};
/**
 * @summary tenants/{tenant}/documentTypes
 */
export var useGetTenantDocumentTypes = function (tenant, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantDocumentTypesKey(tenant) : null); });
    var swrFn = function () {
        return getTenantDocumentTypes(customInstance, tenant, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Content for Downgrade application
 * @summary tenants/{tenant}/applications/downgrade/content
 */
export var getTenantApplicationsDowngradeContent = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/downgrade/content"), method: 'get', params: params }, options);
};
export var getGetTenantApplicationsDowngradeContentKey = function (tenant, params) { return __spreadArray(["/tenants/".concat(tenant, "/applications/downgrade/content")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/applications/downgrade/content
 */
export var useGetTenantApplicationsDowngradeContent = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantApplicationsDowngradeContentKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantApplicationsDowngradeContent(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET - Dynamic Links Configuration
 * @summary tenants/{tenant}/dynamicLinks/configuration
 */
export var getTenantDynamicLinksConfiguration = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/dynamicLinks/configuration"), method: 'get' }, options);
};
export var getGetTenantDynamicLinksConfigurationKey = function (tenant) {
    return ["/tenants/".concat(tenant, "/dynamicLinks/configuration")];
};
/**
 * @summary tenants/{tenant}/dynamicLinks/configuration
 */
export var useGetTenantDynamicLinksConfiguration = function (tenant, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantDynamicLinksConfigurationKey(tenant) : null); });
    var swrFn = function () {
        return getTenantDynamicLinksConfiguration(customInstance, tenant, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Provides dynamic link
 * @summary tenants/{tenant}/dynamicLinkTypes/{dynamicLinkType}/dynamicLink
 */
export var getTenantDynamicLinkTypeDynamicLink = function (client, tenant, dynamicLinkType, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/dynamicLinkTypes/").concat(dynamicLinkType, "/dynamicLink"),
        method: 'get',
        params: params,
    }, options);
};
export var getGetTenantDynamicLinkTypeDynamicLinkKey = function (tenant, dynamicLinkType, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/dynamicLinkTypes/").concat(dynamicLinkType, "/dynamicLink")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/dynamicLinkTypes/{dynamicLinkType}/dynamicLink
 */
export var useGetTenantDynamicLinkTypeDynamicLink = function (tenant, dynamicLinkType, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(tenant && dynamicLinkType);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetTenantDynamicLinkTypeDynamicLinkKey(tenant, dynamicLinkType, params)
            : null;
    });
    var swrFn = function () {
        return getTenantDynamicLinkTypeDynamicLink(customInstance, tenant, dynamicLinkType, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get Earnings app localization
 * @summary tenants/{tenant}/applications/earningsApp/localization
 */
export var getTenantApplicationsEarningsAppLocalization = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/earningsApp/localization"), method: 'get', params: params }, options);
};
export var getGetTenantApplicationsEarningsAppLocalizationKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/earningsApp/localization")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/earningsApp/localization
 */
export var useGetTenantApplicationsEarningsAppLocalization = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantApplicationsEarningsAppLocalizationKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantApplicationsEarningsAppLocalization(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets the search results for specified iPaper url and query using internal iPaper api.
 * @summary tenants/{tenant}/eCatalogueSearchResults/{eCatalogueId}
 */
export var getTenantECatalogueSearchResult = function (client, tenant, eCatalogueId, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/eCatalogueSearchResults/").concat(eCatalogueId), method: 'get', params: params }, options);
};
export var getGetTenantECatalogueSearchResultKey = function (tenant, eCatalogueId, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/eCatalogueSearchResults/").concat(eCatalogueId)
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/eCatalogueSearchResults/{eCatalogueId}
 */
export var useGetTenantECatalogueSearchResult = function (tenant, eCatalogueId, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(tenant && eCatalogueId);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetTenantECatalogueSearchResultKey(tenant, eCatalogueId, params) : null;
    });
    var swrFn = function () {
        return getTenantECatalogueSearchResult(customInstance, tenant, eCatalogueId, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets the structure of eCatalogue for given eCatalogue Id
Internally, the microservice calls the external service twice and then returns the data
 * @summary tenants/{tenant}/eCatalogueStructures/{eCatalogueId}
 */
export var getTenantECatalogueStructure = function (client, tenant, eCatalogueId, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/eCatalogueStructures/").concat(eCatalogueId), method: 'get', params: params }, options);
};
export var getGetTenantECatalogueStructureKey = function (tenant, eCatalogueId, params) {
    return __spreadArray(["/tenants/".concat(tenant, "/eCatalogueStructures/").concat(eCatalogueId)], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/eCatalogueStructures/{eCatalogueId}
 */
export var useGetTenantECatalogueStructure = function (tenant, eCatalogueId, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(tenant && eCatalogueId);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantECatalogueStructureKey(tenant, eCatalogueId, params) : null); });
    var swrFn = function () {
        return getTenantECatalogueStructure(customInstance, tenant, eCatalogueId, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Get editorial pages by query parameters.
 * @summary tenants/{tenant}/applications/editorial/editorialPages
 */
export var getTenantApplicationsEditorialEditorialPages = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/editorial/editorialPages"), method: 'get', params: params }, options);
};
export var getGetTenantApplicationsEditorialEditorialPagesKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/editorial/editorialPages")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/editorial/editorialPages
 */
export var useGetTenantApplicationsEditorialEditorialPages = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantApplicationsEditorialEditorialPagesKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantApplicationsEditorialEditorialPages(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Get editorial header by ids.
 * @summary tenants/{tenant}/applications/editorial/headers
 */
export var getTenantApplicationsEditorialHeaders = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/editorial/headers"), method: 'get', params: params }, options);
};
export var getGetTenantApplicationsEditorialHeadersKey = function (tenant, params) { return __spreadArray(["/tenants/".concat(tenant, "/applications/editorial/headers")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/applications/editorial/headers
 */
export var useGetTenantApplicationsEditorialHeaders = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantApplicationsEditorialHeadersKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantApplicationsEditorialHeaders(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Get product box carousels by ids.
 * @summary tenants/{tenant}/applications/editorial/productBoxCarousels
 */
export var getTenantApplicationsEditorialProductBoxCarousels = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/editorial/productBoxCarousels"), method: 'get', params: params }, options);
};
export var getGetTenantApplicationsEditorialProductBoxCarouselsKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/editorial/productBoxCarousels")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/editorial/productBoxCarousels
 */
export var useGetTenantApplicationsEditorialProductBoxCarousels = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetTenantApplicationsEditorialProductBoxCarouselsKey(tenant, params) : null;
    });
    var swrFn = function () {
        return getTenantApplicationsEditorialProductBoxCarousels(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Get olapics by ids.
 * @summary tenants/{tenant}/applications/editorial/olapics
 */
export var getTenantApplicationsEditorialOlapics = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/editorial/olapics"), method: 'get', params: params }, options);
};
export var getGetTenantApplicationsEditorialOlapicsKey = function (tenant, params) { return __spreadArray(["/tenants/".concat(tenant, "/applications/editorial/olapics")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/applications/editorial/olapics
 */
export var useGetTenantApplicationsEditorialOlapics = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantApplicationsEditorialOlapicsKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantApplicationsEditorialOlapics(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Get banners by ids.
 * @summary tenants/{tenant}/applications/editorial/banners
 */
export var getTenantApplicationsEditorialBanners = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/editorial/banners"), method: 'get', params: params }, options);
};
export var getGetTenantApplicationsEditorialBannersKey = function (tenant, params) { return __spreadArray(["/tenants/".concat(tenant, "/applications/editorial/banners")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/applications/editorial/banners
 */
export var useGetTenantApplicationsEditorialBanners = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantApplicationsEditorialBannersKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantApplicationsEditorialBanners(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Get editorial landing pages by IDs.
 * @summary tenants/{tenant}/applications/editorial/landingPages
 */
export var getTenantApplicationsEditorialLandingPages = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/editorial/landingPages"), method: 'get', params: params }, options);
};
export var getGetTenantApplicationsEditorialLandingPagesKey = function (tenant, params) {
    return __spreadArray(["/tenants/".concat(tenant, "/applications/editorial/landingPages")], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/editorial/landingPages
 */
export var useGetTenantApplicationsEditorialLandingPages = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantApplicationsEditorialLandingPagesKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantApplicationsEditorialLandingPages(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Get editorial pages relative to given collection of pages.
 * @summary tenants/{tenant}/applications/editorial/relatedEditorialPages
 */
export var getTenantApplicationsEditorialRelatedEditorialPages = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/editorial/relatedEditorialPages"),
        method: 'get',
        params: params,
    }, options);
};
export var getGetTenantApplicationsEditorialRelatedEditorialPagesKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/editorial/relatedEditorialPages")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/editorial/relatedEditorialPages
 */
export var useGetTenantApplicationsEditorialRelatedEditorialPages = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetTenantApplicationsEditorialRelatedEditorialPagesKey(tenant, params) : null;
    });
    var swrFn = function () {
        return getTenantApplicationsEditorialRelatedEditorialPages(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Gets mixed PLP content by id
 * @summary tenants/{tenant}/applications/editorial/mixedPlpContents/{contentItemId}
 */
export var getTenantApplicationsEditorialMixedPlpContent = function (client, tenant, contentItemId, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/editorial/mixedPlpContents/").concat(contentItemId),
        method: 'get',
        params: params,
    }, options);
};
export var getGetTenantApplicationsEditorialMixedPlpContentKey = function (tenant, contentItemId, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/editorial/mixedPlpContents/").concat(contentItemId)
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/editorial/mixedPlpContents/{contentItemId}
 */
export var useGetTenantApplicationsEditorialMixedPlpContent = function (tenant, contentItemId, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(tenant && contentItemId);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetTenantApplicationsEditorialMixedPlpContentKey(tenant, contentItemId, params)
            : null;
    });
    var swrFn = function () {
        return getTenantApplicationsEditorialMixedPlpContent(customInstance, tenant, contentItemId, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Get EditorialBanner carousels by IDs
 * @summary tenants/{tenant}/applications/editorial/editorialBannerCarousels
 */
export var getTenantApplicationsEditorialEditorialBannerCarousels = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/editorial/editorialBannerCarousels"),
        method: 'get',
        params: params,
    }, options);
};
export var getGetTenantApplicationsEditorialEditorialBannerCarouselsKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/editorial/editorialBannerCarousels")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/editorial/editorialBannerCarousels
 */
export var useGetTenantApplicationsEditorialEditorialBannerCarousels = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetTenantApplicationsEditorialEditorialBannerCarouselsKey(tenant, params)
            : null;
    });
    var swrFn = function () {
        return getTenantApplicationsEditorialEditorialBannerCarousels(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Get Testimonial carousels by ID
 * @summary tenants/{tenant}/applications/editorial/testimonialCarousels
 */
export var getTenantApplicationsEditorialTestimonialCarousels = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/editorial/testimonialCarousels"),
        method: 'get',
        params: params,
    }, options);
};
export var getGetTenantApplicationsEditorialTestimonialCarouselsKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/editorial/testimonialCarousels")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/editorial/testimonialCarousels
 */
export var useGetTenantApplicationsEditorialTestimonialCarousels = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetTenantApplicationsEditorialTestimonialCarouselsKey(tenant, params) : null;
    });
    var swrFn = function () {
        return getTenantApplicationsEditorialTestimonialCarousels(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Get frequently asked questions by IDs
 * @summary tenants/{tenant}/applications/editorial/frequentlyAskedQuestions
 */
export var getTenantApplicationsEditorialFrequentlyAskedQuestions = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/editorial/frequentlyAskedQuestions"),
        method: 'get',
        params: params,
    }, options);
};
export var getGetTenantApplicationsEditorialFrequentlyAskedQuestionsKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/editorial/frequentlyAskedQuestions")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/editorial/frequentlyAskedQuestions
 */
export var useGetTenantApplicationsEditorialFrequentlyAskedQuestions = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetTenantApplicationsEditorialFrequentlyAskedQuestionsKey(tenant, params)
            : null;
    });
    var swrFn = function () {
        return getTenantApplicationsEditorialFrequentlyAskedQuestions(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Get link lists by IDs.
 * @summary tenants/{tenant}/applications/editorial/linkLists
 */
export var getTenantApplicationsEditorialLinkLists = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/editorial/linkLists"), method: 'get', params: params }, options);
};
export var getGetTenantApplicationsEditorialLinkListsKey = function (tenant, params) { return __spreadArray(["/tenants/".concat(tenant, "/applications/editorial/linkLists")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/applications/editorial/linkLists
 */
export var useGetTenantApplicationsEditorialLinkLists = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantApplicationsEditorialLinkListsKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantApplicationsEditorialLinkLists(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Get fifty fifty banners by IDs
 * @summary tenants/{tenant}/applications/editorial/fiftyBanners
 */
export var getTenantApplicationsEditorialFiftyBanners = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/editorial/fiftyBanners"), method: 'get', params: params }, options);
};
export var getGetTenantApplicationsEditorialFiftyBannersKey = function (tenant, params) {
    return __spreadArray(["/tenants/".concat(tenant, "/applications/editorial/fiftyBanners")], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/editorial/fiftyBanners
 */
export var useGetTenantApplicationsEditorialFiftyBanners = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantApplicationsEditorialFiftyBannersKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantApplicationsEditorialFiftyBanners(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Get benefit modules by IDs
 * @summary tenants/{tenant}/applications/editorial/benefits
 */
export var getTenantApplicationsEditorialBenefits = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/editorial/benefits"), method: 'get', params: params }, options);
};
export var getGetTenantApplicationsEditorialBenefitsKey = function (tenant, params) { return __spreadArray(["/tenants/".concat(tenant, "/applications/editorial/benefits")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/applications/editorial/benefits
 */
export var useGetTenantApplicationsEditorialBenefits = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantApplicationsEditorialBenefitsKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantApplicationsEditorialBenefits(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets collection of editorial articles of specific type, related to products.
 * @summary tenants/{tenant}/editorialArticles
 */
export var getTenantEditorialArticles = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/editorialArticles"), method: 'get', params: params }, options);
};
export var getGetTenantEditorialArticlesKey = function (tenant, params) { return __spreadArray(["/tenants/".concat(tenant, "/editorialArticles")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/editorialArticles
 */
export var useGetTenantEditorialArticles = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantEditorialArticlesKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantEditorialArticles(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Localization for EInvoice application
 * @summary tenants/{tenant}/applications/eInvoice/localization
 */
export var getTenantApplicationsEInvoiceLocalization = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/eInvoice/localization"), method: 'get', params: params }, options);
};
export var getGetTenantApplicationsEInvoiceLocalizationKey = function (tenant, params) {
    return __spreadArray(["/tenants/".concat(tenant, "/applications/eInvoice/localization")], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/eInvoice/localization
 */
export var useGetTenantApplicationsEInvoiceLocalization = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantApplicationsEInvoiceLocalizationKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantApplicationsEInvoiceLocalization(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Localization for EndCustomer Referral Discount application
 * @summary tenants/{tenant}/applications/endCustomerReferralDiscount/localization
 */
export var getTenantApplicationsEndCustomerReferralDiscountLocalization = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/endCustomerReferralDiscount/localization"),
        method: 'get',
        params: params,
    }, options);
};
export var getGetTenantApplicationsEndCustomerReferralDiscountLocalizationKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/endCustomerReferralDiscount/localization")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/endCustomerReferralDiscount/localization
 */
export var useGetTenantApplicationsEndCustomerReferralDiscountLocalization = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetTenantApplicationsEndCustomerReferralDiscountLocalizationKey(tenant, params)
            : null;
    });
    var swrFn = function () {
        return getTenantApplicationsEndCustomerReferralDiscountLocalization(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets identity server endpoints for communication with identity server (API, OAuth, OpenId)
 * @summary tenants/{tenant}/system/endpoints/identityServer
 */
export var getTenantSystemEndpointsIdentityServer = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/system/endpoints/identityServer"), method: 'get' }, options);
};
export var getGetTenantSystemEndpointsIdentityServerKey = function (tenant) {
    return ["/tenants/".concat(tenant, "/system/endpoints/identityServer")];
};
/**
 * @summary tenants/{tenant}/system/endpoints/identityServer
 */
export var useGetTenantSystemEndpointsIdentityServer = function (tenant, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantSystemEndpointsIdentityServerKey(tenant) : null); });
    var swrFn = function () {
        return getTenantSystemEndpointsIdentityServer(customInstance, tenant, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets Online url for specific tenant. It could be used for redirects to oriflame pages
 * @summary tenants/{tenant}/system/endpoints/online
 */
export var getTenantSystemEndpointsOnline = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/system/endpoints/online"), method: 'get', params: params }, options);
};
export var getGetTenantSystemEndpointsOnlineKey = function (tenant, params) { return __spreadArray(["/tenants/".concat(tenant, "/system/endpoints/online")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/system/endpoints/online
 */
export var useGetTenantSystemEndpointsOnline = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantSystemEndpointsOnlineKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantSystemEndpointsOnline(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets Online url for specific tenant. It could be used for redirects to oriflame pages
 * @summary tenants/{tenant}/system/endpoints/graphQLNetServer
 */
export var getTenantSystemEndpointsGraphQLNetServer = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/system/endpoints/graphQLNetServer"), method: 'get' }, options);
};
export var getGetTenantSystemEndpointsGraphQLNetServerKey = function (tenant) {
    return ["/tenants/".concat(tenant, "/system/endpoints/graphQLNetServer")];
};
/**
 * @summary tenants/{tenant}/system/endpoints/graphQLNetServer
 */
export var useGetTenantSystemEndpointsGraphQLNetServer = function (tenant, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantSystemEndpointsGraphQLNetServerKey(tenant) : null); });
    var swrFn = function () {
        return getTenantSystemEndpointsGraphQLNetServer(customInstance, tenant, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets external campaigns for given campaing urls
 * @summary tenants/{tenant}/applications/externalCampaignApp/externalCampaigns
 */
export var getTenantApplicationsExternalCampaignAppExternalCampaigns = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/externalCampaignApp/externalCampaigns"),
        method: 'get',
        params: params,
    }, options);
};
export var getGetTenantApplicationsExternalCampaignAppExternalCampaignsKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/externalCampaignApp/externalCampaigns")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/externalCampaignApp/externalCampaigns
 */
export var useGetTenantApplicationsExternalCampaignAppExternalCampaigns = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetTenantApplicationsExternalCampaignAppExternalCampaignsKey(tenant, params)
            : null;
    });
    var swrFn = function () {
        return getTenantApplicationsExternalCampaignAppExternalCampaigns(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Retrieves the metadata for external providers (FB, WeChat, VKontakte...)
 * @summary tenants/{tenant}/customerExternalProfilesMetadata
 */
export var getTenantCustomerExternalProfilesMetadata = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/customerExternalProfilesMetadata"), method: 'get' }, options);
};
export var getGetTenantCustomerExternalProfilesMetadataKey = function (tenant) {
    return ["/tenants/".concat(tenant, "/customerExternalProfilesMetadata")];
};
/**
 * @summary tenants/{tenant}/customerExternalProfilesMetadata
 */
export var useGetTenantCustomerExternalProfilesMetadata = function (tenant, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantCustomerExternalProfilesMetadataKey(tenant) : null); });
    var swrFn = function () {
        return getTenantCustomerExternalProfilesMetadata(customInstance, tenant, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets feature toggle value for current tenant by the feature GUID.
 * @summary tenants/{tenant}/featureToggles/{featureId}
 */
export var getTenantFeatureToggle = function (client, tenant, featureId, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/featureToggles/").concat(featureId), method: 'get' }, options);
};
export var getGetTenantFeatureToggleKey = function (tenant, featureId) {
    return ["/tenants/".concat(tenant, "/featureToggles/").concat(featureId)];
};
/**
 * @summary tenants/{tenant}/featureToggles/{featureId}
 */
export var useGetTenantFeatureToggle = function (tenant, featureId, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(tenant && featureId);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantFeatureToggleKey(tenant, featureId) : null); });
    var swrFn = function () {
        return getTenantFeatureToggle(customInstance, tenant, featureId, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets all feature toggle values for current tenant.
 * @summary tenants/{tenant}/featureToggles
 */
export var getTenantFeatureToggles = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/featureToggles"), method: 'get' }, options);
};
export var getGetTenantFeatureTogglesKey = function (tenant) {
    return ["/tenants/".concat(tenant, "/featureToggles")];
};
/**
 * @summary tenants/{tenant}/featureToggles
 */
export var useGetTenantFeatureToggles = function (tenant, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantFeatureTogglesKey(tenant) : null); });
    var swrFn = function () {
        return getTenantFeatureToggles(customInstance, tenant, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets feedback benefit banners
 * @summary tenants/{tenant}/applications/banner/feedbackBenefitBanners
 */
export var getTenantApplicationsBannerFeedbackBenefitBanners = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/banner/feedbackBenefitBanners"), method: 'get', params: params }, options);
};
export var getGetTenantApplicationsBannerFeedbackBenefitBannersKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/banner/feedbackBenefitBanners")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/banner/feedbackBenefitBanners
 */
export var useGetTenantApplicationsBannerFeedbackBenefitBanners = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetTenantApplicationsBannerFeedbackBenefitBannersKey(tenant, params) : null;
    });
    var swrFn = function () {
        return getTenantApplicationsBannerFeedbackBenefitBanners(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get footer
 * @summary tenants/{tenant}/applications/footer
 */
export var getTenantApplicationsFooter = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/footer"), method: 'get', params: params }, options);
};
export var getGetTenantApplicationsFooterKey = function (tenant, params) { return __spreadArray(["/tenants/".concat(tenant, "/applications/footer")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/applications/footer
 */
export var useGetTenantApplicationsFooter = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantApplicationsFooterKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantApplicationsFooter(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets collection of formatted price data for products
 * @summary tenants/{tenant}/productsFormattedPrices
 */
export var getTenantProductsFormattedPrices = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/productsFormattedPrices"), method: 'get', params: params }, options);
};
export var getGetTenantProductsFormattedPricesKey = function (tenant, params) { return __spreadArray(["/tenants/".concat(tenant, "/productsFormattedPrices")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/productsFormattedPrices
 */
export var useGetTenantProductsFormattedPrices = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantProductsFormattedPricesKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantProductsFormattedPrices(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets collection of formatted price data for concepts
 * @summary tenants/{tenant}/conceptsFormattedPrices
 */
export var getTenantConceptsFormattedPrices = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/conceptsFormattedPrices"), method: 'get', params: params }, options);
};
export var getGetTenantConceptsFormattedPricesKey = function (tenant, params) { return __spreadArray(["/tenants/".concat(tenant, "/conceptsFormattedPrices")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/conceptsFormattedPrices
 */
export var useGetTenantConceptsFormattedPrices = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantConceptsFormattedPricesKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantConceptsFormattedPrices(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET - provides Product Standards.
 * @summary tenants/{tenant}/applications/frontPage/productStandards
 */
export var getTenantApplicationsFrontPageProductStandards = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/frontPage/productStandards"), method: 'get', params: params }, options);
};
export var getGetTenantApplicationsFrontPageProductStandardsKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/frontPage/productStandards")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/frontPage/productStandards
 */
export var useGetTenantApplicationsFrontPageProductStandards = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetTenantApplicationsFrontPageProductStandardsKey(tenant, params) : null;
    });
    var swrFn = function () {
        return getTenantApplicationsFrontPageProductStandards(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET - provides Motivation Content.
 * @summary tenants/{tenant}/applications/frontPage/motivationContent
 */
export var getTenantApplicationsFrontPageMotivationContent = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/frontPage/motivationContent"), method: 'get', params: params }, options);
};
export var getGetTenantApplicationsFrontPageMotivationContentKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/frontPage/motivationContent")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/frontPage/motivationContent
 */
export var useGetTenantApplicationsFrontPageMotivationContent = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetTenantApplicationsFrontPageMotivationContentKey(tenant, params) : null;
    });
    var swrFn = function () {
        return getTenantApplicationsFrontPageMotivationContent(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET - provides Beauty Edit section's data
 * @summary tenants/{tenant}/applications/frontPage/beautyEdit
 */
export var getTenantApplicationsFrontPageBeautyEdit = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/frontPage/beautyEdit"), method: 'get', params: params }, options);
};
export var getGetTenantApplicationsFrontPageBeautyEditKey = function (tenant, params) { return __spreadArray(["/tenants/".concat(tenant, "/applications/frontPage/beautyEdit")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/applications/frontPage/beautyEdit
 */
export var useGetTenantApplicationsFrontPageBeautyEdit = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantApplicationsFrontPageBeautyEditKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantApplicationsFrontPageBeautyEdit(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET - provides VIP Benefits section's data
 * @summary tenants/{tenant}/applications/frontPage/vipBenefits
 */
export var getTenantApplicationsFrontPageVipBenefits = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/frontPage/vipBenefits"), method: 'get', params: params }, options);
};
export var getGetTenantApplicationsFrontPageVipBenefitsKey = function (tenant, params) {
    return __spreadArray(["/tenants/".concat(tenant, "/applications/frontPage/vipBenefits")], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/frontPage/vipBenefits
 */
export var useGetTenantApplicationsFrontPageVipBenefits = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantApplicationsFrontPageVipBenefitsKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantApplicationsFrontPageVipBenefits(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET - provides Top Brands section's configuration
 * @summary tenants/{tenant}/applications/frontPage/topBrands
 */
export var getTenantApplicationsFrontPageTopBrands = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/frontPage/topBrands"), method: 'get', params: params }, options);
};
export var getGetTenantApplicationsFrontPageTopBrandsKey = function (tenant, params) { return __spreadArray(["/tenants/".concat(tenant, "/applications/frontPage/topBrands")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/applications/frontPage/topBrands
 */
export var useGetTenantApplicationsFrontPageTopBrands = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantApplicationsFrontPageTopBrandsKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantApplicationsFrontPageTopBrands(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET - provides Beauty Video data.
 * @summary tenants/{tenant}/applications/frontPage/beautyVideo
 */
export var getTenantApplicationsFrontPageBeautyVideo = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/frontPage/beautyVideo"), method: 'get', params: params }, options);
};
export var getGetTenantApplicationsFrontPageBeautyVideoKey = function (tenant, params) {
    return __spreadArray(["/tenants/".concat(tenant, "/applications/frontPage/beautyVideo")], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/frontPage/beautyVideo
 */
export var useGetTenantApplicationsFrontPageBeautyVideo = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantApplicationsFrontPageBeautyVideoKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantApplicationsFrontPageBeautyVideo(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET - provides content for the Benefit Banner.
 * @summary tenants/{tenant}/applications/frontPage/benefitBanner
 */
export var getTenantApplicationsFrontPageBenefitBanner = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/frontPage/benefitBanner"), method: 'get', params: params }, options);
};
export var getGetTenantApplicationsFrontPageBenefitBannerKey = function (tenant, params) {
    return __spreadArray(["/tenants/".concat(tenant, "/applications/frontPage/benefitBanner")], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/frontPage/benefitBanner
 */
export var useGetTenantApplicationsFrontPageBenefitBanner = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantApplicationsFrontPageBenefitBannerKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantApplicationsFrontPageBenefitBanner(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET - provides content for the Notification Banner.
 * @summary tenants/{tenant}/applications/frontPage/notificationBanner
 */
export var getTenantApplicationsFrontPageNotificationBanner = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/frontPage/notificationBanner"), method: 'get', params: params }, options);
};
export var getGetTenantApplicationsFrontPageNotificationBannerKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/frontPage/notificationBanner")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/frontPage/notificationBanner
 */
export var useGetTenantApplicationsFrontPageNotificationBanner = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetTenantApplicationsFrontPageNotificationBannerKey(tenant, params) : null;
    });
    var swrFn = function () {
        return getTenantApplicationsFrontPageNotificationBanner(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET - provides content for iconic products
 * @summary tenants/{tenant}/applications/frontPage/iconicProducts
 */
export var getTenantApplicationsFrontPageIconicProducts = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/frontPage/iconicProducts"), method: 'get', params: params }, options);
};
export var getGetTenantApplicationsFrontPageIconicProductsKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/frontPage/iconicProducts")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/frontPage/iconicProducts
 */
export var useGetTenantApplicationsFrontPageIconicProducts = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantApplicationsFrontPageIconicProductsKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantApplicationsFrontPageIconicProducts(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET - provides content for bestseller products
 * @summary tenants/{tenant}/applications/frontPage/bestsellerProducts
 */
export var getTenantApplicationsFrontPageBestsellerProducts = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/frontPage/bestsellerProducts"), method: 'get', params: params }, options);
};
export var getGetTenantApplicationsFrontPageBestsellerProductsKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/frontPage/bestsellerProducts")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/frontPage/bestsellerProducts
 */
export var useGetTenantApplicationsFrontPageBestsellerProducts = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetTenantApplicationsFrontPageBestsellerProductsKey(tenant, params) : null;
    });
    var swrFn = function () {
        return getTenantApplicationsFrontPageBestsellerProducts(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET - provides content for the FrontPage
 * @summary tenants/{tenant}/applications/frontPage
 */
export var getTenantApplicationsFrontPage = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/frontPage"), method: 'get', params: params }, options);
};
export var getGetTenantApplicationsFrontPageKey = function (tenant, params) { return __spreadArray(["/tenants/".concat(tenant, "/applications/frontPage")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/applications/frontPage
 */
export var useGetTenantApplicationsFrontPage = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantApplicationsFrontPageKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantApplicationsFrontPage(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets all defined business activities
 * @summary tenants/{tenant}/applications/gamification/businessActivities
 */
export var getTenantApplicationsGamificationBusinessActivities = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/gamification/businessActivities"),
        method: 'get',
        params: params,
    }, options);
};
export var getGetTenantApplicationsGamificationBusinessActivitiesKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/gamification/businessActivities")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/gamification/businessActivities
 */
export var useGetTenantApplicationsGamificationBusinessActivities = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetTenantApplicationsGamificationBusinessActivitiesKey(tenant, params) : null;
    });
    var swrFn = function () {
        return getTenantApplicationsGamificationBusinessActivities(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Returns Genesys widget metadata
 * @summary tenants/{tenant}/applications/genesysWidget/metadata
 */
export var getTenantApplicationsGenesysWidgetMetadata = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/genesysWidget/metadata"), method: 'get' }, options);
};
export var getGetTenantApplicationsGenesysWidgetMetadataKey = function (tenant) {
    return ["/tenants/".concat(tenant, "/applications/genesysWidget/metadata")];
};
/**
 * @summary tenants/{tenant}/applications/genesysWidget/metadata
 */
export var useGetTenantApplicationsGenesysWidgetMetadata = function (tenant, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantApplicationsGenesysWidgetMetadataKey(tenant) : null); });
    var swrFn = function () {
        return getTenantApplicationsGenesysWidgetMetadata(customInstance, tenant, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Returns Genesys widget page metadata
 * @summary tenants/{tenant}/applications/genesysWidget/pageMetadata
 */
export var getTenantApplicationsGenesysWidgetPageMetadata = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/genesysWidget/pageMetadata"), method: 'get', params: params }, options);
};
export var getGetTenantApplicationsGenesysWidgetPageMetadataKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/genesysWidget/pageMetadata")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/genesysWidget/pageMetadata
 */
export var useGetTenantApplicationsGenesysWidgetPageMetadata = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetTenantApplicationsGenesysWidgetPageMetadataKey(tenant, params) : null;
    });
    var swrFn = function () {
        return getTenantApplicationsGenesysWidgetPageMetadata(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Localization for guarantee credit application
 * @summary tenants/{tenant}/applications/guaranteeCredit/localization
 */
export var getTenantApplicationsGuaranteeCreditLocalization = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/guaranteeCredit/localization"), method: 'get', params: params }, options);
};
export var getGetTenantApplicationsGuaranteeCreditLocalizationKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/guaranteeCredit/localization")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/guaranteeCredit/localization
 */
export var useGetTenantApplicationsGuaranteeCreditLocalization = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetTenantApplicationsGuaranteeCreditLocalizationKey(tenant, params) : null;
    });
    var swrFn = function () {
        return getTenantApplicationsGuaranteeCreditLocalization(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Configuration for guarantee credit application
 * @summary tenants/{tenant}/applications/guaranteeCredit/grantedCreditConfiguration
 */
export var getTenantApplicationsGuaranteeCreditGrantedCreditConfiguration = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/guaranteeCredit/grantedCreditConfiguration"),
        method: 'get',
    }, options);
};
export var getGetTenantApplicationsGuaranteeCreditGrantedCreditConfigurationKey = function (tenant) { return ["/tenants/".concat(tenant, "/applications/guaranteeCredit/grantedCreditConfiguration")]; };
/**
 * @summary tenants/{tenant}/applications/guaranteeCredit/grantedCreditConfiguration
 */
export var useGetTenantApplicationsGuaranteeCreditGrantedCreditConfiguration = function (tenant, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetTenantApplicationsGuaranteeCreditGrantedCreditConfigurationKey(tenant)
            : null;
    });
    var swrFn = function () {
        return getTenantApplicationsGuaranteeCreditGrantedCreditConfiguration(customInstance, tenant, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets the mobile application homepage.
 * @summary tenants/{tenant}/applications/MV7/homepage
 */
export var getTenantApplicationsMV7Homepage = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/MV7/homepage"), method: 'get', params: params }, options);
};
export var getGetTenantApplicationsMV7HomepageKey = function (tenant, params) { return __spreadArray(["/tenants/".concat(tenant, "/applications/MV7/homepage")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/applications/MV7/homepage
 */
export var useGetTenantApplicationsMV7Homepage = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantApplicationsMV7HomepageKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantApplicationsMV7Homepage(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Return possible userSegment types
 * @summary tenants/{tenant}/applications/MV7/usersegmenttypes
 */
export var getTenantApplicationsMV7Usersegmenttypes = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/MV7/usersegmenttypes"), method: 'get', params: params }, options);
};
export var getGetTenantApplicationsMV7UsersegmenttypesKey = function (tenant, params) { return __spreadArray(["/tenants/".concat(tenant, "/applications/MV7/usersegmenttypes")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/applications/MV7/usersegmenttypes
 */
export var useGetTenantApplicationsMV7Usersegmenttypes = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantApplicationsMV7UsersegmenttypesKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantApplicationsMV7Usersegmenttypes(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get Incentives localizations
 * @summary tenants/{tenant}/applications/incentivesApp/localization
 */
export var getTenantApplicationsIncentivesAppLocalization = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/incentivesApp/localization"), method: 'get', params: params }, options);
};
export var getGetTenantApplicationsIncentivesAppLocalizationKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/incentivesApp/localization")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/incentivesApp/localization
 */
export var useGetTenantApplicationsIncentivesAppLocalization = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetTenantApplicationsIncentivesAppLocalizationKey(tenant, params) : null;
    });
    var swrFn = function () {
        return getTenantApplicationsIncentivesAppLocalization(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get Incentives content
 * @summary tenants/{tenant}/applications/incentivesApp/content
 */
export var getTenantApplicationsIncentivesAppContent = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/incentivesApp/content"), method: 'get', params: params }, options);
};
export var getGetTenantApplicationsIncentivesAppContentKey = function (tenant, params) {
    return __spreadArray(["/tenants/".concat(tenant, "/applications/incentivesApp/content")], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/incentivesApp/content
 */
export var useGetTenantApplicationsIncentivesAppContent = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantApplicationsIncentivesAppContentKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantApplicationsIncentivesAppContent(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets collection of Ingredients for given ingredient Names. If collection of ingredients is empty
all ingredients are returned
 * @summary tenants/{tenant}/ingredients
 */
export var getTenantIngredients = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/ingredients"), method: 'get', params: params }, options);
};
export var getGetTenantIngredientsKey = function (tenant, params) {
    return __spreadArray(["/tenants/".concat(tenant, "/ingredients")], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/ingredients
 */
export var useGetTenantIngredients = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantIngredientsKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantIngredients(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets Ingredient for given name
 * @summary tenants/{tenant}/ingredients/{ingredientName}
 */
export var getTenantIngredient = function (client, tenant, ingredientName, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/ingredients/").concat(ingredientName), method: 'get', params: params }, options);
};
export var getGetTenantIngredientKey = function (tenant, ingredientName, params) { return __spreadArray(["/tenants/".concat(tenant, "/ingredients/").concat(ingredientName)], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/ingredients/{ingredientName}
 */
export var useGetTenantIngredient = function (tenant, ingredientName, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(tenant && ingredientName);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantIngredientKey(tenant, ingredientName, params) : null); });
    var swrFn = function () {
        return getTenantIngredient(customInstance, tenant, ingredientName, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets the ingredients inspirations
 * @summary tenants/{tenant}/ingredientsInspirations
 */
export var getTenantIngredientsInspirations = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/ingredientsInspirations"), method: 'get', params: params }, options);
};
export var getGetTenantIngredientsInspirationsKey = function (tenant, params) { return __spreadArray(["/tenants/".concat(tenant, "/ingredientsInspirations")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/ingredientsInspirations
 */
export var useGetTenantIngredientsInspirations = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantIngredientsInspirationsKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantIngredientsInspirations(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get Invite a friend configuration
 * @summary tenants/{tenant}/inviteFriendConfiguration
 */
export var getTenantInviteFriendConfiguration = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/inviteFriendConfiguration"), method: 'get' }, options);
};
export var getGetTenantInviteFriendConfigurationKey = function (tenant) {
    return ["/tenants/".concat(tenant, "/inviteFriendConfiguration")];
};
/**
 * @summary tenants/{tenant}/inviteFriendConfiguration
 */
export var useGetTenantInviteFriendConfiguration = function (tenant, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantInviteFriendConfigurationKey(tenant) : null); });
    var swrFn = function () {
        return getTenantInviteFriendConfiguration(customInstance, tenant, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets Invite a friend / end customer referral program profile for the customer with given consultant number
 * @summary tenants/{tenant}/inviteFriendLinks/{consultantNumber}
 */
export var getTenantInviteFriendLink = function (client, tenant, consultantNumber, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/inviteFriendLinks/").concat(consultantNumber), method: 'get' }, options);
};
export var getGetTenantInviteFriendLinkKey = function (tenant, consultantNumber) {
    return ["/tenants/".concat(tenant, "/inviteFriendLinks/").concat(consultantNumber)];
};
/**
 * @summary tenants/{tenant}/inviteFriendLinks/{consultantNumber}
 */
export var useGetTenantInviteFriendLink = function (tenant, consultantNumber, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(tenant && consultantNumber);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantInviteFriendLinkKey(tenant, consultantNumber) : null); });
    var swrFn = function () {
        return getTenantInviteFriendLink(customInstance, tenant, consultantNumber, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Returns joining fee info and html content
 * @summary tenants/{tenant}/joiningFeeDialog/html
 */
export var getTenantJoiningFeeDialogHtml = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/joiningFeeDialog/html"), method: 'get' }, options);
};
export var getGetTenantJoiningFeeDialogHtmlKey = function (tenant) {
    return ["/tenants/".concat(tenant, "/joiningFeeDialog/html")];
};
/**
 * @summary tenants/{tenant}/joiningFeeDialog/html
 */
export var useGetTenantJoiningFeeDialogHtml = function (tenant, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantJoiningFeeDialogHtmlKey(tenant) : null); });
    var swrFn = function () {
        return getTenantJoiningFeeDialogHtml(customInstance, tenant, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET - returns language configuration for footer.
 * @summary tenants/{tenant}/applications/footer/languageConfiguration
 */
export var getTenantApplicationsFooterLanguageConfiguration = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/footer/languageConfiguration"), method: 'get', params: params }, options);
};
export var getGetTenantApplicationsFooterLanguageConfigurationKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/footer/languageConfiguration")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/footer/languageConfiguration
 */
export var useGetTenantApplicationsFooterLanguageConfiguration = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetTenantApplicationsFooterLanguageConfigurationKey(tenant, params) : null;
    });
    var swrFn = function () {
        return getTenantApplicationsFooterLanguageConfiguration(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET - returns collection of languages for footer.
 * @summary tenants/{tenant}/languages
 */
export var getTenantLanguages = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/languages"), method: 'get' }, options);
};
export var getGetTenantLanguagesKey = function (tenant) {
    return ["/tenants/".concat(tenant, "/languages")];
};
/**
 * @summary tenants/{tenant}/languages
 */
export var useGetTenantLanguages = function (tenant, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantLanguagesKey(tenant) : null); });
    var swrFn = function () {
        return getTenantLanguages(customInstance, tenant, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Returns metadata about legal details of registration with given ID
 * @summary tenants/{tenant}/customerRegistrationsMetadata/{registrationType}/legalDetailsMetadata
 */
export var getTenantCustomerRegistrationsMetadatumLegalDetailsMetadata = function (client, tenant, registrationType, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/customerRegistrationsMetadata/").concat(registrationType, "/legalDetailsMetadata"),
        method: 'get',
    }, options);
};
export var getGetTenantCustomerRegistrationsMetadatumLegalDetailsMetadataKey = function (tenant, registrationType) {
    return [
        "/tenants/".concat(tenant, "/customerRegistrationsMetadata/").concat(registrationType, "/legalDetailsMetadata"),
    ];
};
/**
 * @summary tenants/{tenant}/customerRegistrationsMetadata/{registrationType}/legalDetailsMetadata
 */
export var useGetTenantCustomerRegistrationsMetadatumLegalDetailsMetadata = function (tenant, registrationType, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(tenant && registrationType);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetTenantCustomerRegistrationsMetadatumLegalDetailsMetadataKey(tenant, registrationType)
            : null;
    });
    var swrFn = function () {
        return getTenantCustomerRegistrationsMetadatumLegalDetailsMetadata(customInstance, tenant, registrationType, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Localization strings.
 * @summary tenants/{tenant}/localizations/{id}
 */
export var getTenantLocalization = function (client, tenant, id, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/localizations/").concat(id), method: 'get', params: params }, options);
};
export var getGetTenantLocalizationKey = function (tenant, id, params) { return __spreadArray(["/tenants/".concat(tenant, "/localizations/").concat(id)], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/localizations/{id}
 */
export var useGetTenantLocalization = function (tenant, id, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(tenant && id);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantLocalizationKey(tenant, id, params) : null); });
    var swrFn = function () {
        return getTenantLocalization(customInstance, tenant, id, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Provides list of tenants for SharingApp
 * @summary applications/sharingApp/tenants
 */
export var getApplicationsSharingAppTenants = function (client, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/sharingApp/tenants", method: 'get' }, options);
};
export var getGetApplicationsSharingAppTenantsKey = function () {
    return ["/applications/sharingApp/tenants"];
};
/**
 * @summary applications/sharingApp/tenants
 */
export var useGetApplicationsSharingAppTenants = function (options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetApplicationsSharingAppTenantsKey() : null); });
    var swrFn = function () {
        return getApplicationsSharingAppTenants(customInstance, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Localization for login-sidebar component
 * @summary tenants/{tenant}/applications/loginSidebar/localization
 */
export var getTenantApplicationsLoginSidebarLocalization = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/loginSidebar/localization"), method: 'get' }, options);
};
export var getGetTenantApplicationsLoginSidebarLocalizationKey = function (tenant) {
    return ["/tenants/".concat(tenant, "/applications/loginSidebar/localization")];
};
/**
 * @summary tenants/{tenant}/applications/loginSidebar/localization
 */
export var useGetTenantApplicationsLoginSidebarLocalization = function (tenant, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantApplicationsLoginSidebarLocalizationKey(tenant) : null); });
    var swrFn = function () {
        return getTenantApplicationsLoginSidebarLocalization(customInstance, tenant, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET - Product Detail of Makeup Try On Configuration
 * @summary tenants/{tenant}/applications/makeupTryOn/configuration
 */
export var getTenantApplicationsMakeupTryOnConfiguration = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/makeupTryOn/configuration"), method: 'get', params: params }, options);
};
export var getGetTenantApplicationsMakeupTryOnConfigurationKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/makeupTryOn/configuration")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/makeupTryOn/configuration
 */
export var useGetTenantApplicationsMakeupTryOnConfiguration = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetTenantApplicationsMakeupTryOnConfigurationKey(tenant, params) : null;
    });
    var swrFn = function () {
        return getTenantApplicationsMakeupTryOnConfiguration(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets products relations for given product codes
 * @summary tenants/{tenant}/applications/makeupTryOn/productsRelation
 */
export var getTenantApplicationsMakeupTryOnProductsRelation = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/makeupTryOn/productsRelation"), method: 'get', params: params }, options);
};
export var getGetTenantApplicationsMakeupTryOnProductsRelationKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/makeupTryOn/productsRelation")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/makeupTryOn/productsRelation
 */
export var useGetTenantApplicationsMakeupTryOnProductsRelation = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetTenantApplicationsMakeupTryOnProductsRelationKey(tenant, params) : null;
    });
    var swrFn = function () {
        return getTenantApplicationsMakeupTryOnProductsRelation(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Provides information about manager seminar parameters.
 * @summary tenants/{tenant}/commissionPlanTypes/successPlan/managerSeminarConfiguration
 */
export var getTenantCommissionPlanTypesSuccessPlanManagerSeminarConfiguration = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/commissionPlanTypes/successPlan/managerSeminarConfiguration"),
        method: 'get',
        params: params,
    }, options);
};
export var getGetTenantCommissionPlanTypesSuccessPlanManagerSeminarConfigurationKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/commissionPlanTypes/successPlan/managerSeminarConfiguration")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/commissionPlanTypes/successPlan/managerSeminarConfiguration
 */
export var useGetTenantCommissionPlanTypesSuccessPlanManagerSeminarConfiguration = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetTenantCommissionPlanTypesSuccessPlanManagerSeminarConfigurationKey(tenant, params)
            : null;
    });
    var swrFn = function () {
        return getTenantCommissionPlanTypesSuccessPlanManagerSeminarConfiguration(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Content for Member upgrade application
 * @summary tenants/{tenant}/applications/memberUpgrade/content
 */
export var getTenantApplicationsMemberUpgradeContent = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/memberUpgrade/content"), method: 'get' }, options);
};
export var getGetTenantApplicationsMemberUpgradeContentKey = function (tenant) {
    return ["/tenants/".concat(tenant, "/applications/memberUpgrade/content")];
};
/**
 * @summary tenants/{tenant}/applications/memberUpgrade/content
 */
export var useGetTenantApplicationsMemberUpgradeContent = function (tenant, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantApplicationsMemberUpgradeContentKey(tenant) : null); });
    var swrFn = function () {
        return getTenantApplicationsMemberUpgradeContent(customInstance, tenant, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Configuration for MiniBag SPA
 * @summary tenants/{tenant}/applications/miniBag/configuration
 */
export var getTenantApplicationsMiniBagConfiguration = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/miniBag/configuration"), method: 'get' }, options);
};
export var getGetTenantApplicationsMiniBagConfigurationKey = function (tenant) {
    return ["/tenants/".concat(tenant, "/applications/miniBag/configuration")];
};
/**
 * @summary tenants/{tenant}/applications/miniBag/configuration
 */
export var useGetTenantApplicationsMiniBagConfiguration = function (tenant, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantApplicationsMiniBagConfigurationKey(tenant) : null); });
    var swrFn = function () {
        return getTenantApplicationsMiniBagConfiguration(customInstance, tenant, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets the mobile apps.
 * @summary tenants/{tenant}/mobileApps
 */
export var getTenantMobileApps = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/mobileApps"), method: 'get', params: params }, options);
};
export var getGetTenantMobileAppsKey = function (tenant, params) {
    return __spreadArray(["/tenants/".concat(tenant, "/mobileApps")], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/mobileApps
 */
export var useGetTenantMobileApps = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantMobileAppsKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantMobileApps(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets the mobile app download page header.
 * @summary tenants/{tenant}/applications/mobileApps/pageHeader
 */
export var getTenantApplicationsMobileAppsPageHeader = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/mobileApps/pageHeader"), method: 'get', params: params }, options);
};
export var getGetTenantApplicationsMobileAppsPageHeaderKey = function (tenant, params) {
    return __spreadArray(["/tenants/".concat(tenant, "/applications/mobileApps/pageHeader")], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/mobileApps/pageHeader
 */
export var useGetTenantApplicationsMobileAppsPageHeader = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantApplicationsMobileAppsPageHeaderKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantApplicationsMobileAppsPageHeader(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets links for all existing mobile applications.
 * @summary tenants/{tenant}/mobileAppsLinks
 */
export var getTenantMobileAppsLinks = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/mobileAppsLinks"), method: 'get' }, options);
};
export var getGetTenantMobileAppsLinksKey = function (tenant) {
    return ["/tenants/".concat(tenant, "/mobileAppsLinks")];
};
/**
 * @summary tenants/{tenant}/mobileAppsLinks
 */
export var useGetTenantMobileAppsLinks = function (tenant, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantMobileAppsLinksKey(tenant) : null); });
    var swrFn = function () {
        return getTenantMobileAppsLinks(customInstance, tenant, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Provides configuration for Mobile Office
 * @summary tenants/{tenant}/applications/mobileOffice/configuration
 */
export var getTenantApplicationsMobileOfficeConfiguration = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/mobileOffice/configuration"), method: 'get' }, options);
};
export var getGetTenantApplicationsMobileOfficeConfigurationKey = function (tenant) {
    return ["/tenants/".concat(tenant, "/applications/mobileOffice/configuration")];
};
/**
 * @summary tenants/{tenant}/applications/mobileOffice/configuration
 */
export var useGetTenantApplicationsMobileOfficeConfiguration = function (tenant, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantApplicationsMobileOfficeConfigurationKey(tenant) : null); });
    var swrFn = function () {
        return getTenantApplicationsMobileOfficeConfiguration(customInstance, tenant, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get My Business localization
 * @summary myBusiness/tenants/{tenant}/localization
 */
export var getMyBusinessTenantLocalization = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/myBusiness/tenants/".concat(tenant, "/localization"), method: 'get', params: params }, options);
};
export var getGetMyBusinessTenantLocalizationKey = function (tenant, params) { return __spreadArray(["/myBusiness/tenants/".concat(tenant, "/localization")], (params ? [params] : []), true); };
/**
 * @summary myBusiness/tenants/{tenant}/localization
 */
export var useGetMyBusinessTenantLocalization = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetMyBusinessTenantLocalizationKey(tenant, params) : null); });
    var swrFn = function () {
        return getMyBusinessTenantLocalization(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get MyPages Dashboard localizations
 * @summary tenants/{tenant}/applications/mypagesDashboard/localization
 */
export var getTenantApplicationsMypagesDashboardLocalization = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/mypagesDashboard/localization"), method: 'get', params: params }, options);
};
export var getGetTenantApplicationsMypagesDashboardLocalizationKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/mypagesDashboard/localization")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/mypagesDashboard/localization
 */
export var useGetTenantApplicationsMypagesDashboardLocalization = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetTenantApplicationsMypagesDashboardLocalizationKey(tenant, params) : null;
    });
    var swrFn = function () {
        return getTenantApplicationsMypagesDashboardLocalization(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get category navigation tree or subtree.
 * @summary tenants/{tenant}/applications/MV7/navigationCategories/{category}
 */
export var getTenantApplicationsMV7NavigationCategory = function (client, tenant, category, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/MV7/navigationCategories/").concat(category),
        method: 'get',
        params: params,
    }, options);
};
export var getGetTenantApplicationsMV7NavigationCategoryKey = function (tenant, category, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/MV7/navigationCategories/").concat(category)
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/MV7/navigationCategories/{category}
 */
export var useGetTenantApplicationsMV7NavigationCategory = function (tenant, category, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(tenant && category);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetTenantApplicationsMV7NavigationCategoryKey(tenant, category, params)
            : null;
    });
    var swrFn = function () {
        return getTenantApplicationsMV7NavigationCategory(customInstance, tenant, category, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get brand navigation tree or subtree.
 * @summary tenants/{tenant}/applications/MV7/navigationBrands/{brand}
 */
export var getTenantApplicationsMV7NavigationBrand = function (client, tenant, brand, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/MV7/navigationBrands/").concat(brand), method: 'get', params: params }, options);
};
export var getGetTenantApplicationsMV7NavigationBrandKey = function (tenant, brand, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/MV7/navigationBrands/").concat(brand)
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/MV7/navigationBrands/{brand}
 */
export var useGetTenantApplicationsMV7NavigationBrand = function (tenant, brand, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(tenant && brand);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetTenantApplicationsMV7NavigationBrandKey(tenant, brand, params) : null;
    });
    var swrFn = function () {
        return getTenantApplicationsMV7NavigationBrand(customInstance, tenant, brand, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets concept search results by the specified category.
 * @summary tenants/{tenant}/applications/MV7/navigationCategories/{category}/concepts
 */
export var getTenantApplicationsMV7NavigationCategoryConcepts = function (client, tenant, category, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/MV7/navigationCategories/").concat(category, "/concepts"),
        method: 'get',
        params: params,
    }, options);
};
export var getGetTenantApplicationsMV7NavigationCategoryConceptsKey = function (tenant, category, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/MV7/navigationCategories/").concat(category, "/concepts")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/MV7/navigationCategories/{category}/concepts
 */
export var useGetTenantApplicationsMV7NavigationCategoryConcepts = function (tenant, category, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(tenant && category);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetTenantApplicationsMV7NavigationCategoryConceptsKey(tenant, category, params)
            : null;
    });
    var swrFn = function () {
        return getTenantApplicationsMV7NavigationCategoryConcepts(customInstance, tenant, category, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets concepts by the specified brand.
 * @summary tenants/{tenant}/applications/MV7/navigationBrands/{brand}/concepts
 */
export var getTenantApplicationsMV7NavigationBrandConcepts = function (client, tenant, brand, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/MV7/navigationBrands/").concat(brand, "/concepts"),
        method: 'get',
        params: params,
    }, options);
};
export var getGetTenantApplicationsMV7NavigationBrandConceptsKey = function (tenant, brand, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/MV7/navigationBrands/").concat(brand, "/concepts")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/MV7/navigationBrands/{brand}/concepts
 */
export var useGetTenantApplicationsMV7NavigationBrandConcepts = function (tenant, brand, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(tenant && brand);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetTenantApplicationsMV7NavigationBrandConceptsKey(tenant, brand, params)
            : null;
    });
    var swrFn = function () {
        return getTenantApplicationsMV7NavigationBrandConcepts(customInstance, tenant, brand, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets all concepts with optional filterParams filtering. Useful for root pages of sample-shop, outlet, etc.
 * @summary tenants/{tenant}/applications/MV7/modules/navigationGeneral/concepts
 */
export var getTenantApplicationsMV7ModulesNavigationGeneralConcepts = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/MV7/modules/navigationGeneral/concepts"),
        method: 'get',
        params: params,
    }, options);
};
export var getGetTenantApplicationsMV7ModulesNavigationGeneralConceptsKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/MV7/modules/navigationGeneral/concepts")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/MV7/modules/navigationGeneral/concepts
 */
export var useGetTenantApplicationsMV7ModulesNavigationGeneralConcepts = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetTenantApplicationsMV7ModulesNavigationGeneralConceptsKey(tenant, params)
            : null;
    });
    var swrFn = function () {
        return getTenantApplicationsMV7ModulesNavigationGeneralConcepts(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets search results grouped by concept by the specified category.
 * @summary tenants/{tenant}/applications/navigation/categories/{category}/concepts
 */
export var getTenantApplicationsNavigationCategoryConcepts = function (client, tenant, category, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/navigation/categories/").concat(category, "/concepts"),
        method: 'get',
        params: params,
    }, options);
};
export var getGetTenantApplicationsNavigationCategoryConceptsKey = function (tenant, category, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/navigation/categories/").concat(category, "/concepts")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/navigation/categories/{category}/concepts
 */
export var useGetTenantApplicationsNavigationCategoryConcepts = function (tenant, category, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(tenant && category);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetTenantApplicationsNavigationCategoryConceptsKey(tenant, category, params)
            : null;
    });
    var swrFn = function () {
        return getTenantApplicationsNavigationCategoryConcepts(customInstance, tenant, category, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets search results grouped by concept by the specified brand.
 * @summary tenants/{tenant}/applications/navigation/brands/{brand}/concepts
 */
export var getTenantApplicationsNavigationBrandConcepts = function (client, tenant, brand, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/navigation/brands/").concat(brand, "/concepts"),
        method: 'get',
        params: params,
    }, options);
};
export var getGetTenantApplicationsNavigationBrandConceptsKey = function (tenant, brand, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/navigation/brands/").concat(brand, "/concepts")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/navigation/brands/{brand}/concepts
 */
export var useGetTenantApplicationsNavigationBrandConcepts = function (tenant, brand, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(tenant && brand);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetTenantApplicationsNavigationBrandConceptsKey(tenant, brand, params) : null;
    });
    var swrFn = function () {
        return getTenantApplicationsNavigationBrandConcepts(customInstance, tenant, brand, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets search results grouped by concept with optional filterParams filtering. Useful for root pages of sample-shop, outlet, etc.
 * @summary tenants/{tenant}/applications/navigation/concepts
 */
export var getTenantApplicationsNavigationConcepts = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/navigation/concepts"), method: 'get', params: params }, options);
};
export var getGetTenantApplicationsNavigationConceptsKey = function (tenant, params) { return __spreadArray(["/tenants/".concat(tenant, "/applications/navigation/concepts")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/applications/navigation/concepts
 */
export var useGetTenantApplicationsNavigationConcepts = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantApplicationsNavigationConceptsKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantApplicationsNavigationConcepts(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get navigation items for specific type
 * @summary tenants/{tenant}/applications/navigation/navigations/{navigationType}
 */
export var getTenantApplicationsNavigationNavigation = function (client, tenant, navigationType, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/navigation/navigations/").concat(navigationType),
        method: 'get',
        params: params,
    }, options);
};
export var getGetTenantApplicationsNavigationNavigationKey = function (tenant, navigationType, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/navigation/navigations/").concat(navigationType)
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/navigation/navigations/{navigationType}
 */
export var useGetTenantApplicationsNavigationNavigation = function (tenant, navigationType, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(tenant && navigationType);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetTenantApplicationsNavigationNavigationKey(tenant, navigationType, params)
            : null;
    });
    var swrFn = function () {
        return getTenantApplicationsNavigationNavigation(customInstance, tenant, navigationType, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get top-area navigation definitions for one or more pages
 * @summary tenants/{tenant}/applications/navigation/pageNavigationCollection
 */
export var getTenantApplicationsNavigationPageNavigationCollection = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/navigation/pageNavigationCollection"),
        method: 'get',
        params: params,
    }, options);
};
export var getGetTenantApplicationsNavigationPageNavigationCollectionKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/navigation/pageNavigationCollection")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/navigation/pageNavigationCollection
 */
export var useGetTenantApplicationsNavigationPageNavigationCollection = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetTenantApplicationsNavigationPageNavigationCollectionKey(tenant, params)
            : null;
    });
    var swrFn = function () {
        return getTenantApplicationsNavigationPageNavigationCollection(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Returns collection of tags for chosen related category
 * @summary tenants/{tenant}/navigationTags/{relatedCategory}
 */
export var getTenantNavigationTag = function (client, tenant, relatedCategory, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/navigationTags/").concat(relatedCategory), method: 'get', params: params }, options);
};
export var getGetTenantNavigationTagKey = function (tenant, relatedCategory, params) { return __spreadArray(["/tenants/".concat(tenant, "/navigationTags/").concat(relatedCategory)], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/navigationTags/{relatedCategory}
 */
export var useGetTenantNavigationTag = function (tenant, relatedCategory, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(tenant && relatedCategory);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantNavigationTagKey(tenant, relatedCategory, params) : null); });
    var swrFn = function () {
        return getTenantNavigationTag(customInstance, tenant, relatedCategory, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET - Returns Newsletter Subscription Configuration.
 * @summary tenants/{tenant}/applications/newsletterSubscription/Configuration
 */
export var getTenantApplicationsNewsletterSubscriptionConfiguration = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/newsletterSubscription/Configuration"),
        method: 'get',
        params: params,
    }, options);
};
export var getGetTenantApplicationsNewsletterSubscriptionConfigurationKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/newsletterSubscription/Configuration")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/newsletterSubscription/Configuration
 */
export var useGetTenantApplicationsNewsletterSubscriptionConfiguration = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetTenantApplicationsNewsletterSubscriptionConfigurationKey(tenant, params)
            : null;
    });
    var swrFn = function () {
        return getTenantApplicationsNewsletterSubscriptionConfiguration(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get Notification Web Client localization
 * @summary notifications/tenants/{tenant}/localization
 */
export var getNotificationsTenantLocalization = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/notifications/tenants/".concat(tenant, "/localization"), method: 'get', params: params }, options);
};
export var getGetNotificationsTenantLocalizationKey = function (tenant, params) { return __spreadArray(["/notifications/tenants/".concat(tenant, "/localization")], (params ? [params] : []), true); };
/**
 * @summary notifications/tenants/{tenant}/localization
 */
export var useGetNotificationsTenantLocalization = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetNotificationsTenantLocalizationKey(tenant, params) : null); });
    var swrFn = function () {
        return getNotificationsTenantLocalization(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: NovAge skincare advisor configuration.
 * @summary tenants/{tenant}/applications/advisor/novAgeSkincareConfiguration
 */
export var getTenantApplicationsAdvisorNovAgeSkincareConfiguration = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/advisor/novAgeSkincareConfiguration"),
        method: 'get',
        params: params,
    }, options);
};
export var getGetTenantApplicationsAdvisorNovAgeSkincareConfigurationKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/advisor/novAgeSkincareConfiguration")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/advisor/novAgeSkincareConfiguration
 */
export var useGetTenantApplicationsAdvisorNovAgeSkincareConfiguration = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetTenantApplicationsAdvisorNovAgeSkincareConfigurationKey(tenant, params)
            : null;
    });
    var swrFn = function () {
        return getTenantApplicationsAdvisorNovAgeSkincareConfiguration(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: NovAge skincare advisor localization.
 * @summary tenants/{tenant}/applications/advisor/novAgeSkincareLocalization
 */
export var getTenantApplicationsAdvisorNovAgeSkincareLocalization = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/advisor/novAgeSkincareLocalization"),
        method: 'get',
        params: params,
    }, options);
};
export var getGetTenantApplicationsAdvisorNovAgeSkincareLocalizationKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/advisor/novAgeSkincareLocalization")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/advisor/novAgeSkincareLocalization
 */
export var useGetTenantApplicationsAdvisorNovAgeSkincareLocalization = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetTenantApplicationsAdvisorNovAgeSkincareLocalizationKey(tenant, params)
            : null;
    });
    var swrFn = function () {
        return getTenantApplicationsAdvisorNovAgeSkincareLocalization(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Returns configurations for given olapic type and optional parameters.
 * @summary tenants/{tenant}/applications/olapic/configuration
 */
export var getTenantApplicationsOlapicConfiguration = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/olapic/configuration"), method: 'get', params: params }, options);
};
export var getGetTenantApplicationsOlapicConfigurationKey = function (tenant, params) { return __spreadArray(["/tenants/".concat(tenant, "/applications/olapic/configuration")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/applications/olapic/configuration
 */
export var useGetTenantApplicationsOlapicConfiguration = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantApplicationsOlapicConfigurationKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantApplicationsOlapicConfiguration(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Content for On behalf registration confirmation application
 * @summary tenants/{tenant}/applications/onBehalfRegistrationConfirmation/content
 */
export var getTenantApplicationsOnBehalfRegistrationConfirmationContent = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/onBehalfRegistrationConfirmation/content"),
        method: 'get',
    }, options);
};
export var getGetTenantApplicationsOnBehalfRegistrationConfirmationContentKey = function (tenant) { return ["/tenants/".concat(tenant, "/applications/onBehalfRegistrationConfirmation/content")]; };
/**
 * @summary tenants/{tenant}/applications/onBehalfRegistrationConfirmation/content
 */
export var useGetTenantApplicationsOnBehalfRegistrationConfirmationContent = function (tenant, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetTenantApplicationsOnBehalfRegistrationConfirmationContentKey(tenant)
            : null;
    });
    var swrFn = function () {
        return getTenantApplicationsOnBehalfRegistrationConfirmationContent(customInstance, tenant, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Configuration for On behalf registration confirmation application
 * @summary tenants/{tenant}/applications/onBehalfRegistrationConfirmation/configuration
 */
export var getTenantApplicationsOnBehalfRegistrationConfirmationConfiguration = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/onBehalfRegistrationConfirmation/configuration"),
        method: 'get',
    }, options);
};
export var getGetTenantApplicationsOnBehalfRegistrationConfirmationConfigurationKey = function (tenant) { return ["/tenants/".concat(tenant, "/applications/onBehalfRegistrationConfirmation/configuration")]; };
/**
 * @summary tenants/{tenant}/applications/onBehalfRegistrationConfirmation/configuration
 */
export var useGetTenantApplicationsOnBehalfRegistrationConfirmationConfiguration = function (tenant, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetTenantApplicationsOnBehalfRegistrationConfirmationConfigurationKey(tenant)
            : null;
    });
    var swrFn = function () {
        return getTenantApplicationsOnBehalfRegistrationConfirmationConfiguration(customInstance, tenant, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Localization for Onboarding application
 * @summary tenants/{tenant}/applications/onboarding/localization
 */
export var getTenantApplicationsOnboardingLocalization = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/onboarding/localization"), method: 'get' }, options);
};
export var getGetTenantApplicationsOnboardingLocalizationKey = function (tenant) {
    return ["/tenants/".concat(tenant, "/applications/onboarding/localization")];
};
/**
 * @summary tenants/{tenant}/applications/onboarding/localization
 */
export var useGetTenantApplicationsOnboardingLocalization = function (tenant, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantApplicationsOnboardingLocalizationKey(tenant) : null); });
    var swrFn = function () {
        return getTenantApplicationsOnboardingLocalization(customInstance, tenant, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Localization for Order History application
 * @summary tenants/{tenant}/applications/orderHistory/localization
 */
export var getTenantApplicationsOrderHistoryLocalization = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/orderHistory/localization"), method: 'get' }, options);
};
export var getGetTenantApplicationsOrderHistoryLocalizationKey = function (tenant) {
    return ["/tenants/".concat(tenant, "/applications/orderHistory/localization")];
};
/**
 * @summary tenants/{tenant}/applications/orderHistory/localization
 */
export var useGetTenantApplicationsOrderHistoryLocalization = function (tenant, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantApplicationsOrderHistoryLocalizationKey(tenant) : null); });
    var swrFn = function () {
        return getTenantApplicationsOrderHistoryLocalization(customInstance, tenant, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Returns meta information for specified pageId. Publicly cached for 10 minutes.
 * @summary tenants/{tenant}/pageMetaData
 */
export var getTenantPageMetaData = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/pageMetaData"), method: 'get', params: params }, options);
};
export var getGetTenantPageMetaDataKey = function (tenant, params) {
    return __spreadArray(["/tenants/".concat(tenant, "/pageMetaData")], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/pageMetaData
 */
export var useGetTenantPageMetaData = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantPageMetaDataKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantPageMetaData(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Provides link to the game page.
 * @summary tenants/{tenant}/pages/gamepage/dynamiclink
 */
export var getTenantPagesGamepageDynamiclink = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/pages/gamepage/dynamiclink"), method: 'get', params: params }, options);
};
export var getGetTenantPagesGamepageDynamiclinkKey = function (tenant, params) { return __spreadArray(["/tenants/".concat(tenant, "/pages/gamepage/dynamiclink")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/pages/gamepage/dynamiclink
 */
export var useGetTenantPagesGamepageDynamiclink = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantPagesGamepageDynamiclinkKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantPagesGamepageDynamiclink(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Provides link to the homepage.
 * @summary tenants/{tenant}/pages/homepage/dynamiclink
 */
export var getTenantPagesHomepageDynamiclink = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/pages/homepage/dynamiclink"), method: 'get', params: params }, options);
};
export var getGetTenantPagesHomepageDynamiclinkKey = function (tenant, params) { return __spreadArray(["/tenants/".concat(tenant, "/pages/homepage/dynamiclink")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/pages/homepage/dynamiclink
 */
export var useGetTenantPagesHomepageDynamiclink = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantPagesHomepageDynamiclinkKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantPagesHomepageDynamiclink(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Brand partner content for parental consent application
 * @summary tenants/{tenant}/applications/parentalConsent/brandPartnerContent
 */
export var getTenantApplicationsParentalConsentBrandPartnerContent = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/parentalConsent/brandPartnerContent"),
        method: 'get',
        params: params,
    }, options);
};
export var getGetTenantApplicationsParentalConsentBrandPartnerContentKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/parentalConsent/brandPartnerContent")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/parentalConsent/brandPartnerContent
 */
export var useGetTenantApplicationsParentalConsentBrandPartnerContent = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetTenantApplicationsParentalConsentBrandPartnerContentKey(tenant, params)
            : null;
    });
    var swrFn = function () {
        return getTenantApplicationsParentalConsentBrandPartnerContent(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: VIP registration content for parental consent application
 * @summary tenants/{tenant}/applications/parentalConsent/vipRegistrationContent
 */
export var getTenantApplicationsParentalConsentVipRegistrationContent = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/parentalConsent/vipRegistrationContent"),
        method: 'get',
        params: params,
    }, options);
};
export var getGetTenantApplicationsParentalConsentVipRegistrationContentKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/parentalConsent/vipRegistrationContent")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/parentalConsent/vipRegistrationContent
 */
export var useGetTenantApplicationsParentalConsentVipRegistrationContent = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetTenantApplicationsParentalConsentVipRegistrationContentKey(tenant, params)
            : null;
    });
    var swrFn = function () {
        return getTenantApplicationsParentalConsentVipRegistrationContent(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets payment method configurations
 * @summary tenants/{tenant}/applications/configuration/paymentMethods
 */
export var getTenantApplicationsConfigurationPaymentMethods = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/configuration/paymentMethods"), method: 'get', params: params }, options);
};
export var getGetTenantApplicationsConfigurationPaymentMethodsKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/configuration/paymentMethods")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/configuration/paymentMethods
 */
export var useGetTenantApplicationsConfigurationPaymentMethods = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetTenantApplicationsConfigurationPaymentMethodsKey(tenant, params) : null;
    });
    var swrFn = function () {
        return getTenantApplicationsConfigurationPaymentMethods(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET current period information
 * @summary tenants/{tenant}/periods/currentPeriod
 */
export var getTenantPeriodsCurrentPeriod = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/periods/currentPeriod"), method: 'get' }, options);
};
export var getGetTenantPeriodsCurrentPeriodKey = function (tenant) {
    return ["/tenants/".concat(tenant, "/periods/currentPeriod")];
};
/**
 * @summary tenants/{tenant}/periods/currentPeriod
 */
export var useGetTenantPeriodsCurrentPeriod = function (tenant, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantPeriodsCurrentPeriodKey(tenant) : null); });
    var swrFn = function () {
        return getTenantPeriodsCurrentPeriod(customInstance, tenant, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets top area permanent banners
 * @summary tenants/{tenant}/applications/banner/permanentTopAreaBanners
 */
export var getTenantApplicationsBannerPermanentTopAreaBanners = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/banner/permanentTopAreaBanners"),
        method: 'get',
        params: params,
    }, options);
};
export var getGetTenantApplicationsBannerPermanentTopAreaBannersKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/banner/permanentTopAreaBanners")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/banner/permanentTopAreaBanners
 */
export var useGetTenantApplicationsBannerPermanentTopAreaBanners = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetTenantApplicationsBannerPermanentTopAreaBannersKey(tenant, params) : null;
    });
    var swrFn = function () {
        return getTenantApplicationsBannerPermanentTopAreaBanners(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets enriched top area permanent banners from GraphQL
 * @summary tenants/{tenant}/applications/banner/enrichedPermanentTopAreaBanners
 */
export var getTenantApplicationsBannerEnrichedPermanentTopAreaBanners = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/banner/enrichedPermanentTopAreaBanners"),
        method: 'get',
        params: params,
    }, options);
};
export var getGetTenantApplicationsBannerEnrichedPermanentTopAreaBannersKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/banner/enrichedPermanentTopAreaBanners")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/banner/enrichedPermanentTopAreaBanners
 */
export var useGetTenantApplicationsBannerEnrichedPermanentTopAreaBanners = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetTenantApplicationsBannerEnrichedPermanentTopAreaBannersKey(tenant, params)
            : null;
    });
    var swrFn = function () {
        return getTenantApplicationsBannerEnrichedPermanentTopAreaBanners(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Provides product permissions
 * @summary tenants/{tenant}/products/{productCode}/permission
 */
export var getTenantProductPermission = function (client, tenant, productCode, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/products/").concat(productCode, "/permission"), method: 'get', params: params }, options);
};
export var getGetTenantProductPermissionKey = function (tenant, productCode, params) {
    return __spreadArray(["/tenants/".concat(tenant, "/products/").concat(productCode, "/permission")], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/products/{productCode}/permission
 */
export var useGetTenantProductPermission = function (tenant, productCode, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(tenant && productCode);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantProductPermissionKey(tenant, productCode, params) : null); });
    var swrFn = function () {
        return getTenantProductPermission(customInstance, tenant, productCode, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Provides concept permissions
 * @summary tenants/{tenant}/concepts/{conceptCode}/permission
 */
export var getTenantConceptPermission = function (client, tenant, conceptCode, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/concepts/").concat(conceptCode, "/permission"), method: 'get', params: params }, options);
};
export var getGetTenantConceptPermissionKey = function (tenant, conceptCode, params) {
    return __spreadArray(["/tenants/".concat(tenant, "/concepts/").concat(conceptCode, "/permission")], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/concepts/{conceptCode}/permission
 */
export var useGetTenantConceptPermission = function (tenant, conceptCode, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(tenant && conceptCode);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantConceptPermissionKey(tenant, conceptCode, params) : null); });
    var swrFn = function () {
        return getTenantConceptPermission(customInstance, tenant, conceptCode, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get personal beauty store localization
 * @summary personalBeautyStore/tenants/{tenant}/localization
 */
export var getPersonalBeautyStoreTenantLocalization = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/personalBeautyStore/tenants/".concat(tenant, "/localization"), method: 'get', params: params }, options);
};
export var getGetPersonalBeautyStoreTenantLocalizationKey = function (tenant, params) { return __spreadArray(["/personalBeautyStore/tenants/".concat(tenant, "/localization")], (params ? [params] : []), true); };
/**
 * @summary personalBeautyStore/tenants/{tenant}/localization
 */
export var useGetPersonalBeautyStoreTenantLocalization = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetPersonalBeautyStoreTenantLocalizationKey(tenant, params) : null); });
    var swrFn = function () {
        return getPersonalBeautyStoreTenantLocalization(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get tenant personal beauty store configuration.
 * @summary tenants/{tenant}/applications/personalBeautyStore/configuration
 */
export var getTenantApplicationsPersonalBeautyStoreConfiguration = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/personalBeautyStore/configuration"), method: 'get' }, options);
};
export var getGetTenantApplicationsPersonalBeautyStoreConfigurationKey = function (tenant) {
    return ["/tenants/".concat(tenant, "/applications/personalBeautyStore/configuration")];
};
/**
 * @summary tenants/{tenant}/applications/personalBeautyStore/configuration
 */
export var useGetTenantApplicationsPersonalBeautyStoreConfiguration = function (tenant, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetTenantApplicationsPersonalBeautyStoreConfigurationKey(tenant) : null;
    });
    var swrFn = function () {
        return getTenantApplicationsPersonalBeautyStoreConfiguration(customInstance, tenant, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Returns metadata about personal details of registration with given ID
 * @summary tenants/{tenant}/customerRegistrationsMetadata/{registrationType}/personalDetailsMetadata
 */
export var getTenantCustomerRegistrationsMetadatumPersonalDetailsMetadata = function (client, tenant, registrationType, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/customerRegistrationsMetadata/").concat(registrationType, "/personalDetailsMetadata"),
        method: 'get',
    }, options);
};
export var getGetTenantCustomerRegistrationsMetadatumPersonalDetailsMetadataKey = function (tenant, registrationType) {
    return [
        "/tenants/".concat(tenant, "/customerRegistrationsMetadata/").concat(registrationType, "/personalDetailsMetadata"),
    ];
};
/**
 * @summary tenants/{tenant}/customerRegistrationsMetadata/{registrationType}/personalDetailsMetadata
 */
export var useGetTenantCustomerRegistrationsMetadatumPersonalDetailsMetadata = function (tenant, registrationType, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(tenant && registrationType);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetTenantCustomerRegistrationsMetadatumPersonalDetailsMetadataKey(tenant, registrationType)
            : null;
    });
    var swrFn = function () {
        return getTenantCustomerRegistrationsMetadatumPersonalDetailsMetadata(customInstance, tenant, registrationType, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get Personal Group Listing localization
 * @summary personalGroupListing/tenants/{tenant}/localization
 */
export var getPersonalGroupListingTenantLocalization = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/personalGroupListing/tenants/".concat(tenant, "/localization"), method: 'get', params: params }, options);
};
export var getGetPersonalGroupListingTenantLocalizationKey = function (tenant, params) { return __spreadArray(["/personalGroupListing/tenants/".concat(tenant, "/localization")], (params ? [params] : []), true); };
/**
 * @summary personalGroupListing/tenants/{tenant}/localization
 */
export var useGetPersonalGroupListingTenantLocalization = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetPersonalGroupListingTenantLocalizationKey(tenant, params) : null); });
    var swrFn = function () {
        return getPersonalGroupListingTenantLocalization(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get Personal Group Overview localization
 * @summary personalGroupOverview/tenants/{tenant}/localization
 */
export var getPersonalGroupOverviewTenantLocalization = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/personalGroupOverview/tenants/".concat(tenant, "/localization"), method: 'get', params: params }, options);
};
export var getGetPersonalGroupOverviewTenantLocalizationKey = function (tenant, params) {
    return __spreadArray(["/personalGroupOverview/tenants/".concat(tenant, "/localization")], (params ? [params] : []), true);
};
/**
 * @summary personalGroupOverview/tenants/{tenant}/localization
 */
export var useGetPersonalGroupOverviewTenantLocalization = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetPersonalGroupOverviewTenantLocalizationKey(tenant, params) : null); });
    var swrFn = function () {
        return getPersonalGroupOverviewTenantLocalization(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get Personal Menu localization
 * @summary applications/personalMenu/tenants/{tenant}/localization
 */
export var getApplicationsPersonalMenuTenantLocalization = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/personalMenu/tenants/".concat(tenant, "/localization"), method: 'get', params: params }, options);
};
export var getGetApplicationsPersonalMenuTenantLocalizationKey = function (tenant, params) {
    return __spreadArray([
        "/applications/personalMenu/tenants/".concat(tenant, "/localization")
    ], (params ? [params] : []), true);
};
/**
 * @summary applications/personalMenu/tenants/{tenant}/localization
 */
export var useGetApplicationsPersonalMenuTenantLocalization = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetApplicationsPersonalMenuTenantLocalizationKey(tenant, params) : null;
    });
    var swrFn = function () {
        return getApplicationsPersonalMenuTenantLocalization(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Returns options for telephone formatting
 * @summary tenants/{tenant}/phoneFormats
 */
export var getTenantPhoneFormats = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/phoneFormats"), method: 'get' }, options);
};
export var getGetTenantPhoneFormatsKey = function (tenant) {
    return ["/tenants/".concat(tenant, "/phoneFormats")];
};
/**
 * @summary tenants/{tenant}/phoneFormats
 */
export var useGetTenantPhoneFormats = function (tenant, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantPhoneFormatsKey(tenant) : null); });
    var swrFn = function () {
        return getTenantPhoneFormats(customInstance, tenant, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Provides information about product price
 * @summary tenants/{tenant}/products/{productCode}/price
 */
export var getTenantProductPrice = function (client, tenant, productCode, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/products/").concat(productCode, "/price"), method: 'get', params: params }, options);
};
export var getGetTenantProductPriceKey = function (tenant, productCode, params) { return __spreadArray(["/tenants/".concat(tenant, "/products/").concat(productCode, "/price")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/products/{productCode}/price
 */
export var useGetTenantProductPrice = function (tenant, productCode, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(tenant && productCode);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantProductPriceKey(tenant, productCode, params) : null); });
    var swrFn = function () {
        return getTenantProductPrice(customInstance, tenant, productCode, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Provides information about concept price
 * @summary tenants/{tenant}/concepts/{conceptCode}/price
 */
export var getTenantConceptPrice = function (client, tenant, conceptCode, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/concepts/").concat(conceptCode, "/price"), method: 'get', params: params }, options);
};
export var getGetTenantConceptPriceKey = function (tenant, conceptCode, params) { return __spreadArray(["/tenants/".concat(tenant, "/concepts/").concat(conceptCode, "/price")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/concepts/{conceptCode}/price
 */
export var useGetTenantConceptPrice = function (tenant, conceptCode, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(tenant && conceptCode);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantConceptPriceKey(tenant, conceptCode, params) : null); });
    var swrFn = function () {
        return getTenantConceptPrice(customInstance, tenant, conceptCode, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get product box
 * @summary tenants/{tenant}/applications/productBox
 */
export var getTenantApplicationsProductBox = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/productBox"), method: 'get', params: params }, options);
};
export var getGetTenantApplicationsProductBoxKey = function (tenant, params) { return __spreadArray(["/tenants/".concat(tenant, "/applications/productBox")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/applications/productBox
 */
export var useGetTenantApplicationsProductBox = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantApplicationsProductBoxKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantApplicationsProductBox(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets product configuration for product box
 * @summary tenants/{tenant}/applications/productbox/configuration
 */
export var getTenantApplicationsProductboxConfiguration = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/productbox/configuration"), method: 'get', params: params }, options);
};
export var getGetTenantApplicationsProductboxConfigurationKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/productbox/configuration")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/productbox/configuration
 */
export var useGetTenantApplicationsProductboxConfiguration = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantApplicationsProductboxConfigurationKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantApplicationsProductboxConfiguration(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets single product bundle by product code
 * @summary tenants/{tenant}/productBundles/{productCode}
 */
export var getTenantProductBundle = function (client, tenant, productCode, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/productBundles/").concat(productCode), method: 'get', params: params }, options);
};
export var getGetTenantProductBundleKey = function (tenant, productCode, params) { return __spreadArray(["/tenants/".concat(tenant, "/productBundles/").concat(productCode)], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/productBundles/{productCode}
 */
export var useGetTenantProductBundle = function (tenant, productCode, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(tenant && productCode);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantProductBundleKey(tenant, productCode, params) : null); });
    var swrFn = function () {
        return getTenantProductBundle(customInstance, tenant, productCode, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets collection of product bundles
 * @summary tenants/{tenant}/productBundles
 */
export var getTenantProductBundles = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/productBundles"), method: 'get', params: params }, options);
};
export var getGetTenantProductBundlesKey = function (tenant, params) { return __spreadArray(["/tenants/".concat(tenant, "/productBundles")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/productBundles
 */
export var useGetTenantProductBundles = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantProductBundlesKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantProductBundles(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET - Product Detail Configuration
 * @summary tenants/{tenant}/applications/productDetail/configuration
 */
export var getTenantApplicationsProductDetailConfiguration = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/productDetail/configuration"), method: 'get', params: params }, options);
};
export var getGetTenantApplicationsProductDetailConfigurationKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/productDetail/configuration")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/productDetail/configuration
 */
export var useGetTenantApplicationsProductDetailConfiguration = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetTenantApplicationsProductDetailConfigurationKey(tenant, params) : null;
    });
    var swrFn = function () {
        return getTenantApplicationsProductDetailConfiguration(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET - Tooling banners for given products
 * @summary tenants/{tenant}/applications/productDetail/toolingBanners
 */
export var getTenantApplicationsProductDetailToolingBanners = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/productDetail/toolingBanners"), method: 'get', params: params }, options);
};
export var getGetTenantApplicationsProductDetailToolingBannersKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/productDetail/toolingBanners")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/productDetail/toolingBanners
 */
export var useGetTenantApplicationsProductDetailToolingBanners = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetTenantApplicationsProductDetailToolingBannersKey(tenant, params) : null;
    });
    var swrFn = function () {
        return getTenantApplicationsProductDetailToolingBanners(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET - Editorial carousels for given products
 * @summary tenants/{tenant}/applications/productDetail/editorialCarousels
 */
export var getTenantApplicationsProductDetailEditorialCarousels = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/productDetail/editorialCarousels"),
        method: 'get',
        params: params,
    }, options);
};
export var getGetTenantApplicationsProductDetailEditorialCarouselsKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/productDetail/editorialCarousels")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/productDetail/editorialCarousels
 */
export var useGetTenantApplicationsProductDetailEditorialCarousels = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetTenantApplicationsProductDetailEditorialCarouselsKey(tenant, params)
            : null;
    });
    var swrFn = function () {
        return getTenantApplicationsProductDetailEditorialCarousels(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET - Product Detail Page metadata
 * @summary tenants/{tenant}/applications/productDetail/products/{productCode}/pageMetaData
 */
export var getTenantApplicationsProductDetailProductPageMetaData = function (client, tenant, productCode, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/productDetail/products/").concat(productCode, "/pageMetaData"),
        method: 'get',
        params: params,
    }, options);
};
export var getGetTenantApplicationsProductDetailProductPageMetaDataKey = function (tenant, productCode, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/productDetail/products/").concat(productCode, "/pageMetaData")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/productDetail/products/{productCode}/pageMetaData
 */
export var useGetTenantApplicationsProductDetailProductPageMetaData = function (tenant, productCode, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(tenant && productCode);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetTenantApplicationsProductDetailProductPageMetaDataKey(tenant, productCode, params)
            : null;
    });
    var swrFn = function () {
        return getTenantApplicationsProductDetailProductPageMetaData(customInstance, tenant, productCode, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get Breadcrumbs links for product detail.
 * @summary tenants/{tenant}/applications/productDetail/products/{productCode}/breadcrumbLinks
 */
export var getTenantApplicationsProductDetailProductBreadcrumbLinks = function (client, tenant, productCode, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/productDetail/products/").concat(productCode, "/breadcrumbLinks"),
        method: 'get',
        params: params,
    }, options);
};
export var getGetTenantApplicationsProductDetailProductBreadcrumbLinksKey = function (tenant, productCode, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/productDetail/products/").concat(productCode, "/breadcrumbLinks")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/productDetail/products/{productCode}/breadcrumbLinks
 */
export var useGetTenantApplicationsProductDetailProductBreadcrumbLinks = function (tenant, productCode, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(tenant && productCode);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetTenantApplicationsProductDetailProductBreadcrumbLinksKey(tenant, productCode, params)
            : null;
    });
    var swrFn = function () {
        return getTenantApplicationsProductDetailProductBreadcrumbLinks(customInstance, tenant, productCode, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET - Product Detail Sections content
 * @summary tenants/{tenant}/applications/productDetail/sections
 */
export var getTenantApplicationsProductDetailSections = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/productDetail/sections"), method: 'get', params: params }, options);
};
export var getGetTenantApplicationsProductDetailSectionsKey = function (tenant, params) {
    return __spreadArray(["/tenants/".concat(tenant, "/applications/productDetail/sections")], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/productDetail/sections
 */
export var useGetTenantApplicationsProductDetailSections = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantApplicationsProductDetailSectionsKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantApplicationsProductDetailSections(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets calculated attributes for producr from product index.
 * @summary tenants/{tenant}/productIndexItems
 */
export var getTenantProductIndexItems = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/productIndexItems"), method: 'get', params: params }, options);
};
export var getGetTenantProductIndexItemsKey = function (tenant, params) { return __spreadArray(["/tenants/".concat(tenant, "/productIndexItems")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/productIndexItems
 */
export var useGetTenantProductIndexItems = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantProductIndexItemsKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantProductIndexItems(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Provides collection of Product Labels' contents.
 * @summary tenants/{tenant}/productLabelsContent
 */
export var getTenantProductLabelsContent = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/productLabelsContent"), method: 'get', params: params }, options);
};
export var getGetTenantProductLabelsContentKey = function (tenant, params) { return __spreadArray(["/tenants/".concat(tenant, "/productLabelsContent")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/productLabelsContent
 */
export var useGetTenantProductLabelsContent = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantProductLabelsContentKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantProductLabelsContent(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get product listing with products and promo banners based on ID
 * @deprecated
 * @summary tenants/{tenant}/applications/MV7/productlistings
 */
export var getTenantApplicationsMV7Productlistings = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/MV7/productlistings"), method: 'get', params: params }, options);
};
export var getGetTenantApplicationsMV7ProductlistingsKey = function (tenant, params) { return __spreadArray(["/tenants/".concat(tenant, "/applications/MV7/productlistings")], (params ? [params] : []), true); };
/**
 * @deprecated
 * @summary tenants/{tenant}/applications/MV7/productlistings
 */
export var useGetTenantApplicationsMV7Productlistings = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantApplicationsMV7ProductlistingsKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantApplicationsMV7Productlistings(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Get product sorting strategies definitions.
 * @summary tenants/{tenant}/applications/productListing/sortDefinitions
 */
export var getTenantApplicationsProductListingSortDefinitions = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/productListing/sortDefinitions"),
        method: 'get',
        params: params,
    }, options);
};
export var getGetTenantApplicationsProductListingSortDefinitionsKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/productListing/sortDefinitions")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/productListing/sortDefinitions
 */
export var useGetTenantApplicationsProductListingSortDefinitions = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetTenantApplicationsProductListingSortDefinitionsKey(tenant, params) : null;
    });
    var swrFn = function () {
        return getTenantApplicationsProductListingSortDefinitions(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets the product listings data for Mv7 mobile app.
 * @summary tenants/{tenant}/applications/mv7/productListingsV2
 */
export var getTenantApplicationsMv7ProductListingsV2 = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/mv7/productListingsV2"), method: 'get', params: params }, options);
};
export var getGetTenantApplicationsMv7ProductListingsV2Key = function (tenant, params) {
    return __spreadArray(["/tenants/".concat(tenant, "/applications/mv7/productListingsV2")], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/mv7/productListingsV2
 */
export var useGetTenantApplicationsMv7ProductListingsV2 = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantApplicationsMv7ProductListingsV2Key(tenant, params) : null); });
    var swrFn = function () {
        return getTenantApplicationsMv7ProductListingsV2(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Provides product list link.
 * @summary tenants/{tenant}/productlists/{productListId}/dynamiclink
 */
export var getTenantProductlistDynamiclink = function (client, tenant, productListId, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/productlists/").concat(productListId, "/dynamiclink"), method: 'get', params: params }, options);
};
export var getGetTenantProductlistDynamiclinkKey = function (tenant, productListId, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/productlists/").concat(productListId, "/dynamiclink")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/productlists/{productListId}/dynamiclink
 */
export var useGetTenantProductlistDynamiclink = function (tenant, productListId, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(tenant && productListId);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetTenantProductlistDynamiclinkKey(tenant, productListId, params) : null;
    });
    var swrFn = function () {
        return getTenantProductlistDynamiclink(customInstance, tenant, productListId, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET - Provides product media URLs.
 * @summary tenants/{tenant}/products/{productCode}/media
 */
export var getTenantProductMedia = function (client, tenant, productCode, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/products/").concat(productCode, "/media"), method: 'get', params: params }, options);
};
export var getGetTenantProductMediaKey = function (tenant, productCode, params) { return __spreadArray(["/tenants/".concat(tenant, "/products/").concat(productCode, "/media")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/products/{productCode}/media
 */
export var useGetTenantProductMedia = function (tenant, productCode, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(tenant && productCode);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantProductMediaKey(tenant, productCode, params) : null); });
    var swrFn = function () {
        return getTenantProductMedia(customInstance, tenant, productCode, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Provides product
 * @summary tenants/{tenant}/deprecatedProducts/{productCode}
 */
export var getTenantDeprecatedProduct = function (client, tenant, productCode, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/deprecatedProducts/").concat(productCode), method: 'get', params: params }, options);
};
export var getGetTenantDeprecatedProductKey = function (tenant, productCode, params) { return __spreadArray(["/tenants/".concat(tenant, "/deprecatedProducts/").concat(productCode)], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/deprecatedProducts/{productCode}
 */
export var useGetTenantDeprecatedProduct = function (tenant, productCode, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(tenant && productCode);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantDeprecatedProductKey(tenant, productCode, params) : null); });
    var swrFn = function () {
        return getTenantDeprecatedProduct(customInstance, tenant, productCode, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Provides dynamic link to a single product.
 * @summary tenants/{tenant}/products/{productCode}/dynamiclink
 */
export var getTenantProductDynamiclink = function (client, tenant, productCode, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/products/").concat(productCode, "/dynamiclink"), method: 'get', params: params }, options);
};
export var getGetTenantProductDynamiclinkKey = function (tenant, productCode, params) {
    return __spreadArray(["/tenants/".concat(tenant, "/products/").concat(productCode, "/dynamiclink")], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/products/{productCode}/dynamiclink
 */
export var useGetTenantProductDynamiclink = function (tenant, productCode, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(tenant && productCode);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantProductDynamiclinkKey(tenant, productCode, params) : null); });
    var swrFn = function () {
        return getTenantProductDynamiclink(customInstance, tenant, productCode, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Provides product from product service
 * @summary tenants/{tenant}/products/{productCode}
 */
export var getTenantProduct = function (client, tenant, productCode, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/products/").concat(productCode), method: 'get', params: params }, options);
};
export var getGetTenantProductKey = function (tenant, productCode, params) { return __spreadArray(["/tenants/".concat(tenant, "/products/").concat(productCode)], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/products/{productCode}
 */
export var useGetTenantProduct = function (tenant, productCode, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(tenant && productCode);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantProductKey(tenant, productCode, params) : null); });
    var swrFn = function () {
        return getTenantProduct(customInstance, tenant, productCode, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets the product data for Mv7 mobile app.
 * @summary tenants/{tenant}/applications/mv7/modules/productsRepository/products
 */
export var getTenantApplicationsMv7ModulesProductsRepositoryProducts = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/mv7/modules/productsRepository/products"),
        method: 'get',
        params: params,
    }, options);
};
export var getGetTenantApplicationsMv7ModulesProductsRepositoryProductsKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/mv7/modules/productsRepository/products")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/mv7/modules/productsRepository/products
 */
export var useGetTenantApplicationsMv7ModulesProductsRepositoryProducts = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetTenantApplicationsMv7ModulesProductsRepositoryProductsKey(tenant, params)
            : null;
    });
    var swrFn = function () {
        return getTenantApplicationsMv7ModulesProductsRepositoryProducts(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets the products hashcodes data for Mv7 mobile app.
 * @summary tenants/{tenant}/applications/mv7/modules/productsRepository/productsHashCodes
 */
export var getTenantApplicationsMv7ModulesProductsRepositoryProductsHashCodes = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/mv7/modules/productsRepository/productsHashCodes"),
        method: 'get',
        params: params,
    }, options);
};
export var getGetTenantApplicationsMv7ModulesProductsRepositoryProductsHashCodesKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/mv7/modules/productsRepository/productsHashCodes")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/mv7/modules/productsRepository/productsHashCodes
 */
export var useGetTenantApplicationsMv7ModulesProductsRepositoryProductsHashCodes = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetTenantApplicationsMv7ModulesProductsRepositoryProductsHashCodesKey(tenant, params)
            : null;
    });
    var swrFn = function () {
        return getTenantApplicationsMv7ModulesProductsRepositoryProductsHashCodes(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets the products tooling banners data for Mv7 mobile app.
 * @summary tenants/{tenant}/applications/mv7/modules/productsRepository/productsToolingBanners
 */
export var getTenantApplicationsMv7ModulesProductsRepositoryProductsToolingBanners = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/mv7/modules/productsRepository/productsToolingBanners"),
        method: 'get',
        params: params,
    }, options);
};
export var getGetTenantApplicationsMv7ModulesProductsRepositoryProductsToolingBannersKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/mv7/modules/productsRepository/productsToolingBanners")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/mv7/modules/productsRepository/productsToolingBanners
 */
export var useGetTenantApplicationsMv7ModulesProductsRepositoryProductsToolingBanners = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetTenantApplicationsMv7ModulesProductsRepositoryProductsToolingBannersKey(tenant, params)
            : null;
    });
    var swrFn = function () {
        return getTenantApplicationsMv7ModulesProductsRepositoryProductsToolingBanners(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets the products expected inbounds
 * @summary tenants/{tenant}/productsExpectedInbounds
 */
export var getTenantProductsExpectedInbounds = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/productsExpectedInbounds"), method: 'get', params: params }, options);
};
export var getGetTenantProductsExpectedInboundsKey = function (tenant, params) { return __spreadArray(["/tenants/".concat(tenant, "/productsExpectedInbounds")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/productsExpectedInbounds
 */
export var useGetTenantProductsExpectedInbounds = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantProductsExpectedInboundsKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantProductsExpectedInbounds(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets the products ingredients
 * @summary tenants/{tenant}/productsIngredients
 */
export var getTenantProductsIngredients = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/productsIngredients"), method: 'get', params: params }, options);
};
export var getGetTenantProductsIngredientsKey = function (tenant, params) { return __spreadArray(["/tenants/".concat(tenant, "/productsIngredients")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/productsIngredients
 */
export var useGetTenantProductsIngredients = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantProductsIngredientsKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantProductsIngredients(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets collection of product labels for anonymous customer.
 * @summary tenants/{tenant}/productsLabels
 */
export var getTenantProductsLabels = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/productsLabels"), method: 'get', params: params }, options);
};
export var getGetTenantProductsLabelsKey = function (tenant, params) { return __spreadArray(["/tenants/".concat(tenant, "/productsLabels")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/productsLabels
 */
export var useGetTenantProductsLabels = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantProductsLabelsKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantProductsLabels(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets the products labels data for Mv7 mobile app.
 * @summary tenants/{tenant}/applications/mv7/modules/productsLabelsRepository/productsLabels
 */
export var getTenantApplicationsMv7ModulesProductsLabelsRepositoryProductsLabels = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/mv7/modules/productsLabelsRepository/productsLabels"),
        method: 'get',
        params: params,
    }, options);
};
export var getGetTenantApplicationsMv7ModulesProductsLabelsRepositoryProductsLabelsKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/mv7/modules/productsLabelsRepository/productsLabels")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/mv7/modules/productsLabelsRepository/productsLabels
 */
export var useGetTenantApplicationsMv7ModulesProductsLabelsRepositoryProductsLabels = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetTenantApplicationsMv7ModulesProductsLabelsRepositoryProductsLabelsKey(tenant, params)
            : null;
    });
    var swrFn = function () {
        return getTenantApplicationsMv7ModulesProductsLabelsRepositoryProductsLabels(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets products manufacturers.
 * @summary tenants/{tenant}/productsManufacturers
 */
export var getTenantProductsManufacturers = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/productsManufacturers"), method: 'get', params: params }, options);
};
export var getGetTenantProductsManufacturersKey = function (tenant, params) { return __spreadArray(["/tenants/".concat(tenant, "/productsManufacturers")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/productsManufacturers
 */
export var useGetTenantProductsManufacturers = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantProductsManufacturersKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantProductsManufacturers(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets the products prices data for Mv7 mobile app.
 * @summary tenants/{tenant}/applications/mv7/modules/productsPricesRepository/productsPrices
 */
export var getTenantApplicationsMv7ModulesProductsPricesRepositoryProductsPrices = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/mv7/modules/productsPricesRepository/productsPrices"),
        method: 'get',
        params: params,
    }, options);
};
export var getGetTenantApplicationsMv7ModulesProductsPricesRepositoryProductsPricesKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/mv7/modules/productsPricesRepository/productsPrices")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/mv7/modules/productsPricesRepository/productsPrices
 */
export var useGetTenantApplicationsMv7ModulesProductsPricesRepositoryProductsPrices = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetTenantApplicationsMv7ModulesProductsPricesRepositoryProductsPricesKey(tenant, params)
            : null;
    });
    var swrFn = function () {
        return getTenantApplicationsMv7ModulesProductsPricesRepositoryProductsPrices(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Returns 6 recommended products for the user, based on behavioral similarity.
 * @summary tenants/{tenant}/users/{userId}/recommendations
 */
export var getTenantUserRecommendations = function (client, tenant, userId, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/users/").concat(userId, "/recommendations"), method: 'get', params: params }, options);
};
export var getGetTenantUserRecommendationsKey = function (tenant, userId, params) { return __spreadArray(["/tenants/".concat(tenant, "/users/").concat(userId, "/recommendations")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/users/{userId}/recommendations
 */
export var useGetTenantUserRecommendations = function (tenant, userId, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(tenant && userId);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantUserRecommendationsKey(tenant, userId, params) : null); });
    var swrFn = function () {
        return getTenantUserRecommendations(customInstance, tenant, userId, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Returns 6 recommended products for certain product, based on behavioral similarity of the users.
 * @summary tenants/{tenant}/products/{productCode}/recommendations
 */
export var getTenantProductRecommendations = function (client, tenant, productCode, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/products/").concat(productCode, "/recommendations"), method: 'get', params: params }, options);
};
export var getGetTenantProductRecommendationsKey = function (tenant, productCode, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/products/").concat(productCode, "/recommendations")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/products/{productCode}/recommendations
 */
export var useGetTenantProductRecommendations = function (tenant, productCode, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(tenant && productCode);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantProductRecommendationsKey(tenant, productCode, params) : null); });
    var swrFn = function () {
        return getTenantProductRecommendations(customInstance, tenant, productCode, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets products replacements for specific customer.
 * @summary tenants/{tenant}/productsReplacements
 */
export var getTenantProductsReplacements = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/productsReplacements"), method: 'get', params: params }, options);
};
export var getGetTenantProductsReplacementsKey = function (tenant, params) { return __spreadArray(["/tenants/".concat(tenant, "/productsReplacements")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/productsReplacements
 */
export var useGetTenantProductsReplacements = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantProductsReplacementsKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantProductsReplacements(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Localization for profile application
 * @summary tenants/{tenant}/applications/profile/localization
 */
export var getTenantApplicationsProfileLocalization = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/profile/localization"), method: 'get' }, options);
};
export var getGetTenantApplicationsProfileLocalizationKey = function (tenant) {
    return ["/tenants/".concat(tenant, "/applications/profile/localization")];
};
/**
 * @summary tenants/{tenant}/applications/profile/localization
 */
export var useGetTenantApplicationsProfileLocalization = function (tenant, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantApplicationsProfileLocalizationKey(tenant) : null); });
    var swrFn = function () {
        return getTenantApplicationsProfileLocalization(customInstance, tenant, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Content for Profile application
 * @summary tenants/{tenant}/applications/profile/content
 */
export var getTenantApplicationsProfileContent = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/profile/content"), method: 'get', params: params }, options);
};
export var getGetTenantApplicationsProfileContentKey = function (tenant, params) { return __spreadArray(["/tenants/".concat(tenant, "/applications/profile/content")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/applications/profile/content
 */
export var useGetTenantApplicationsProfileContent = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantApplicationsProfileContentKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantApplicationsProfileContent(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * @summary tenants/{tenant}/profileApprovalMetadata
 */
export var getTenantProfileApprovalMetadata = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/profileApprovalMetadata"), method: 'get' }, options);
};
export var getGetTenantProfileApprovalMetadataKey = function (tenant) {
    return ["/tenants/".concat(tenant, "/profileApprovalMetadata")];
};
/**
 * @summary tenants/{tenant}/profileApprovalMetadata
 */
export var useGetTenantProfileApprovalMetadata = function (tenant, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantProfileApprovalMetadataKey(tenant) : null); });
    var swrFn = function () {
        return getTenantProfileApprovalMetadata(customInstance, tenant, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get information about promo banner
 * @summary tenants/{tenant}/applications/mobileOffice/promoBanner
 */
export var getTenantApplicationsMobileOfficePromoBanner = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/mobileOffice/promoBanner"), method: 'get', params: params }, options);
};
export var getGetTenantApplicationsMobileOfficePromoBannerKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/mobileOffice/promoBanner")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/mobileOffice/promoBanner
 */
export var useGetTenantApplicationsMobileOfficePromoBanner = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantApplicationsMobileOfficePromoBannerKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantApplicationsMobileOfficePromoBanner(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets best offers banners
 * @summary tenants/{tenant}/promotions/banners/bestoffers
 */
export var getTenantPromotionsBannersBestoffers = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/promotions/banners/bestoffers"), method: 'get', params: params }, options);
};
export var getGetTenantPromotionsBannersBestoffersKey = function (tenant, params) { return __spreadArray(["/tenants/".concat(tenant, "/promotions/banners/bestoffers")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/promotions/banners/bestoffers
 */
export var useGetTenantPromotionsBannersBestoffers = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantPromotionsBannersBestoffersKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantPromotionsBannersBestoffers(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets whats new type banners
 * @summary tenants/{tenant}/promotions/banners/whatsnew
 */
export var getTenantPromotionsBannersWhatsnew = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/promotions/banners/whatsnew"), method: 'get', params: params }, options);
};
export var getGetTenantPromotionsBannersWhatsnewKey = function (tenant, params) { return __spreadArray(["/tenants/".concat(tenant, "/promotions/banners/whatsnew")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/promotions/banners/whatsnew
 */
export var useGetTenantPromotionsBannersWhatsnew = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantPromotionsBannersWhatsnewKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantPromotionsBannersWhatsnew(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets hero banners
 * @summary tenants/{tenant}/promotions/banners/hero
 */
export var getTenantPromotionsBannersHero = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/promotions/banners/hero"), method: 'get', params: params }, options);
};
export var getGetTenantPromotionsBannersHeroKey = function (tenant, params) { return __spreadArray(["/tenants/".concat(tenant, "/promotions/banners/hero")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/promotions/banners/hero
 */
export var useGetTenantPromotionsBannersHero = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantPromotionsBannersHeroKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantPromotionsBannersHero(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets campaign banners
 * @summary tenants/{tenant}/promotions/banners/campaign
 */
export var getTenantPromotionsBannersCampaign = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/promotions/banners/campaign"), method: 'get', params: params }, options);
};
export var getGetTenantPromotionsBannersCampaignKey = function (tenant, params) { return __spreadArray(["/tenants/".concat(tenant, "/promotions/banners/campaign")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/promotions/banners/campaign
 */
export var useGetTenantPromotionsBannersCampaign = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantPromotionsBannersCampaignKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantPromotionsBannersCampaign(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets category banners
 * @summary tenants/{tenant}/promotions/banners/category
 */
export var getTenantPromotionsBannersCategory = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/promotions/banners/category"), method: 'get', params: params }, options);
};
export var getGetTenantPromotionsBannersCategoryKey = function (tenant, params) { return __spreadArray(["/tenants/".concat(tenant, "/promotions/banners/category")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/promotions/banners/category
 */
export var useGetTenantPromotionsBannersCategory = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantPromotionsBannersCategoryKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantPromotionsBannersCategory(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets current promotions
 * @summary tenants/{tenant}/digitalPromotions
 */
export var getTenantDigitalPromotions = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/digitalPromotions"), method: 'get', params: params }, options);
};
export var getGetTenantDigitalPromotionsKey = function (tenant, params) { return __spreadArray(["/tenants/".concat(tenant, "/digitalPromotions")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/digitalPromotions
 */
export var useGetTenantDigitalPromotions = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantDigitalPromotionsKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantDigitalPromotions(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET - returns Ratings and reviews configuration
 * @summary tenants/{tenant}/applications/ratingsAndReviewsApp/configuration
 */
export var getTenantApplicationsRatingsAndReviewsAppConfiguration = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/ratingsAndReviewsApp/configuration"),
        method: 'get',
        params: params,
    }, options);
};
export var getGetTenantApplicationsRatingsAndReviewsAppConfigurationKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/ratingsAndReviewsApp/configuration")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/ratingsAndReviewsApp/configuration
 */
export var useGetTenantApplicationsRatingsAndReviewsAppConfiguration = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetTenantApplicationsRatingsAndReviewsAppConfigurationKey(tenant, params)
            : null;
    });
    var swrFn = function () {
        return getTenantApplicationsRatingsAndReviewsAppConfiguration(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Localization for RealTime Order Tracking application
 * @summary tenants/{tenant}/applications/realTimeOrderTracking/localization
 */
export var getTenantApplicationsRealTimeOrderTrackingLocalization = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/realTimeOrderTracking/localization"),
        method: 'get',
        params: params,
    }, options);
};
export var getGetTenantApplicationsRealTimeOrderTrackingLocalizationKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/realTimeOrderTracking/localization")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/realTimeOrderTracking/localization
 */
export var useGetTenantApplicationsRealTimeOrderTrackingLocalization = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetTenantApplicationsRealTimeOrderTrackingLocalizationKey(tenant, params)
            : null;
    });
    var swrFn = function () {
        return getTenantApplicationsRealTimeOrderTrackingLocalization(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Get RealTimeOrderTracking
 * @summary tenants/{tenant}/realtimeOrderTrackings/{orderId}
 */
export var getTenantRealtimeOrderTracking = function (client, tenant, orderId, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/realtimeOrderTrackings/").concat(orderId), method: 'get', params: params }, options);
};
export var getGetTenantRealtimeOrderTrackingKey = function (tenant, orderId, params) { return __spreadArray(["/tenants/".concat(tenant, "/realtimeOrderTrackings/").concat(orderId)], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/realtimeOrderTrackings/{orderId}
 */
export var useGetTenantRealtimeOrderTracking = function (tenant, orderId, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(tenant && orderId);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantRealtimeOrderTrackingKey(tenant, orderId, params) : null); });
    var swrFn = function () {
        return getTenantRealtimeOrderTracking(customInstance, tenant, orderId, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Returns metadata about pre-step of registration
 * @summary tenants/{tenant}/customerRegistrationsMetadata/{registrationType}/registrationsMetadata
 */
export var getTenantCustomerRegistrationsMetadatumRegistrationsMetadata = function (client, tenant, registrationType, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/customerRegistrationsMetadata/").concat(registrationType, "/registrationsMetadata"),
        method: 'get',
    }, options);
};
export var getGetTenantCustomerRegistrationsMetadatumRegistrationsMetadataKey = function (tenant, registrationType) {
    return [
        "/tenants/".concat(tenant, "/customerRegistrationsMetadata/").concat(registrationType, "/registrationsMetadata"),
    ];
};
/**
 * @summary tenants/{tenant}/customerRegistrationsMetadata/{registrationType}/registrationsMetadata
 */
export var useGetTenantCustomerRegistrationsMetadatumRegistrationsMetadata = function (tenant, registrationType, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(tenant && registrationType);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetTenantCustomerRegistrationsMetadatumRegistrationsMetadataKey(tenant, registrationType)
            : null;
    });
    var swrFn = function () {
        return getTenantCustomerRegistrationsMetadatumRegistrationsMetadata(customInstance, tenant, registrationType, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET - Provides related product codes and relation types.
 * @summary tenants/{tenant}/products/{productCode}/relations
 */
export var getTenantProductRelations = function (client, tenant, productCode, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/products/").concat(productCode, "/relations"), method: 'get', params: params }, options);
};
export var getGetTenantProductRelationsKey = function (tenant, productCode, params) { return __spreadArray(["/tenants/".concat(tenant, "/products/").concat(productCode, "/relations")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/products/{productCode}/relations
 */
export var useGetTenantProductRelations = function (tenant, productCode, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(tenant && productCode);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantProductRelationsKey(tenant, productCode, params) : null); });
    var swrFn = function () {
        return getTenantProductRelations(customInstance, tenant, productCode, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Returns metadata for reports SPA
 * @summary tenants/{tenant}/applications/reportsSpa/metadata
 */
export var getTenantApplicationsReportsSpaMetadata = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/reportsSpa/metadata"), method: 'get' }, options);
};
export var getGetTenantApplicationsReportsSpaMetadataKey = function (tenant) {
    return ["/tenants/".concat(tenant, "/applications/reportsSpa/metadata")];
};
/**
 * @summary tenants/{tenant}/applications/reportsSpa/metadata
 */
export var useGetTenantApplicationsReportsSpaMetadata = function (tenant, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantApplicationsReportsSpaMetadataKey(tenant) : null); });
    var swrFn = function () {
        return getTenantApplicationsReportsSpaMetadata(customInstance, tenant, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Dummy endpoint
 * @summary tenants/{tenant}/sample
 */
export var getTenantSample = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/sample"), method: 'get' }, options);
};
export var getGetTenantSampleKey = function (tenant) { return ["/tenants/".concat(tenant, "/sample")]; };
/**
 * @summary tenants/{tenant}/sample
 */
export var useGetTenantSample = function (tenant, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantSampleKey(tenant) : null); });
    var swrFn = function () { return getTenantSample(customInstance, tenant, requestOptions).then(function (d) { return d.data; }); };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Provides seminar parameters.
 * @summary tenants/{tenant}/seminarParams
 */
export var getTenantSeminarParams = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/seminarParams"), method: 'get', params: params }, options);
};
export var getGetTenantSeminarParamsKey = function (tenant, params) { return __spreadArray(["/tenants/".concat(tenant, "/seminarParams")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/seminarParams
 */
export var useGetTenantSeminarParams = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantSeminarParamsKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantSeminarParams(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets available facets for each category to use in search filters.
 * @summary tenants/{tenant}/applications/MV7/facetSettings
 */
export var getTenantApplicationsMV7FacetSettings = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/MV7/facetSettings"), method: 'get' }, options);
};
export var getGetTenantApplicationsMV7FacetSettingsKey = function (tenant) {
    return ["/tenants/".concat(tenant, "/applications/MV7/facetSettings")];
};
/**
 * @summary tenants/{tenant}/applications/MV7/facetSettings
 */
export var useGetTenantApplicationsMV7FacetSettings = function (tenant, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantApplicationsMV7FacetSettingsKey(tenant) : null); });
    var swrFn = function () {
        return getTenantApplicationsMV7FacetSettings(customInstance, tenant, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get share and earn page
 * @summary tenants/{tenant}/applications/shareAndEarn/page
 */
export var getTenantApplicationsShareAndEarnPage = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/shareAndEarn/page"), method: 'get', params: params }, options);
};
export var getGetTenantApplicationsShareAndEarnPageKey = function (tenant, params) { return __spreadArray(["/tenants/".concat(tenant, "/applications/shareAndEarn/page")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/applications/shareAndEarn/page
 */
export var useGetTenantApplicationsShareAndEarnPage = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantApplicationsShareAndEarnPageKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantApplicationsShareAndEarnPage(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get share and earn page
 * @summary tenants/{tenant}/applications/shareAndEarn/personalLinksContent
 */
export var getTenantApplicationsShareAndEarnPersonalLinksContent = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/shareAndEarn/personalLinksContent"),
        method: 'get',
        params: params,
    }, options);
};
export var getGetTenantApplicationsShareAndEarnPersonalLinksContentKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/shareAndEarn/personalLinksContent")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/shareAndEarn/personalLinksContent
 */
export var useGetTenantApplicationsShareAndEarnPersonalLinksContent = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetTenantApplicationsShareAndEarnPersonalLinksContentKey(tenant, params)
            : null;
    });
    var swrFn = function () {
        return getTenantApplicationsShareAndEarnPersonalLinksContent(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get sharing conditions
 * @summary tenants/{tenant}/applications/shareAndEarn/sharingConditions
 */
export var getTenantApplicationsShareAndEarnSharingConditions = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/shareAndEarn/sharingConditions"),
        method: 'get',
        params: params,
    }, options);
};
export var getGetTenantApplicationsShareAndEarnSharingConditionsKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/shareAndEarn/sharingConditions")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/shareAndEarn/sharingConditions
 */
export var useGetTenantApplicationsShareAndEarnSharingConditions = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetTenantApplicationsShareAndEarnSharingConditionsKey(tenant, params) : null;
    });
    var swrFn = function () {
        return getTenantApplicationsShareAndEarnSharingConditions(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get personal code edit page
 * @summary tenants/{tenant}/applications/shareAndEarn/personalCodeEditPage
 */
export var getTenantApplicationsShareAndEarnPersonalCodeEditPage = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/shareAndEarn/personalCodeEditPage"),
        method: 'get',
        params: params,
    }, options);
};
export var getGetTenantApplicationsShareAndEarnPersonalCodeEditPageKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/shareAndEarn/personalCodeEditPage")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/shareAndEarn/personalCodeEditPage
 */
export var useGetTenantApplicationsShareAndEarnPersonalCodeEditPage = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetTenantApplicationsShareAndEarnPersonalCodeEditPageKey(tenant, params)
            : null;
    });
    var swrFn = function () {
        return getTenantApplicationsShareAndEarnPersonalCodeEditPage(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get customer data for personal code
 * @summary tenants/{tenant}/applications/shareAndEarn/personalCodes/{personalCode}/customer
 */
export var getTenantApplicationsShareAndEarnPersonalCodeCustomer = function (client, tenant, personalCode, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/shareAndEarn/personalCodes/").concat(personalCode, "/customer"),
        method: 'get',
        params: params,
    }, options);
};
export var getGetTenantApplicationsShareAndEarnPersonalCodeCustomerKey = function (tenant, personalCode, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/shareAndEarn/personalCodes/").concat(personalCode, "/customer")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/shareAndEarn/personalCodes/{personalCode}/customer
 */
export var useGetTenantApplicationsShareAndEarnPersonalCodeCustomer = function (tenant, personalCode, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(tenant && personalCode);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetTenantApplicationsShareAndEarnPersonalCodeCustomerKey(tenant, personalCode, params)
            : null;
    });
    var swrFn = function () {
        return getTenantApplicationsShareAndEarnPersonalCodeCustomer(customInstance, tenant, personalCode, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Return SharingApp media URLs for specified tenant
 * @summary applications/sharingApp/tenants/{tenant}/media
 */
export var getApplicationsSharingAppTenantMedia = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/sharingApp/tenants/".concat(tenant, "/media"), method: 'get', params: params }, options);
};
export var getGetApplicationsSharingAppTenantMediaKey = function (tenant, params) { return __spreadArray(["/applications/sharingApp/tenants/".concat(tenant, "/media")], (params ? [params] : []), true); };
/**
 * @summary applications/sharingApp/tenants/{tenant}/media
 */
export var useGetApplicationsSharingAppTenantMedia = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetApplicationsSharingAppTenantMediaKey(tenant, params) : null); });
    var swrFn = function () {
        return getApplicationsSharingAppTenantMedia(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Localization for brand partner's simplified registration application
 * @summary tenants/{tenant}/applications/simplifiedRegistration/brandPartnerLocalization
 */
export var getTenantApplicationsSimplifiedRegistrationBrandPartnerLocalization = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/simplifiedRegistration/brandPartnerLocalization"),
        method: 'get',
    }, options);
};
export var getGetTenantApplicationsSimplifiedRegistrationBrandPartnerLocalizationKey = function (tenant) { return ["/tenants/".concat(tenant, "/applications/simplifiedRegistration/brandPartnerLocalization")]; };
/**
 * @summary tenants/{tenant}/applications/simplifiedRegistration/brandPartnerLocalization
 */
export var useGetTenantApplicationsSimplifiedRegistrationBrandPartnerLocalization = function (tenant, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetTenantApplicationsSimplifiedRegistrationBrandPartnerLocalizationKey(tenant)
            : null;
    });
    var swrFn = function () {
        return getTenantApplicationsSimplifiedRegistrationBrandPartnerLocalization(customInstance, tenant, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Localization for VIP customer's simplified registration application
 * @summary tenants/{tenant}/applications/simplifiedRegistration/vipCustomerLocalization
 */
export var getTenantApplicationsSimplifiedRegistrationVipCustomerLocalization = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/simplifiedRegistration/vipCustomerLocalization"),
        method: 'get',
    }, options);
};
export var getGetTenantApplicationsSimplifiedRegistrationVipCustomerLocalizationKey = function (tenant) { return ["/tenants/".concat(tenant, "/applications/simplifiedRegistration/vipCustomerLocalization")]; };
/**
 * @summary tenants/{tenant}/applications/simplifiedRegistration/vipCustomerLocalization
 */
export var useGetTenantApplicationsSimplifiedRegistrationVipCustomerLocalization = function (tenant, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetTenantApplicationsSimplifiedRegistrationVipCustomerLocalizationKey(tenant)
            : null;
    });
    var swrFn = function () {
        return getTenantApplicationsSimplifiedRegistrationVipCustomerLocalization(customInstance, tenant, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Content for brand partner's simplified registration application
 * @summary tenants/{tenant}/applications/simplifiedRegistration/brandPartnerContent
 */
export var getTenantApplicationsSimplifiedRegistrationBrandPartnerContent = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/simplifiedRegistration/brandPartnerContent"),
        method: 'get',
        params: params,
    }, options);
};
export var getGetTenantApplicationsSimplifiedRegistrationBrandPartnerContentKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/simplifiedRegistration/brandPartnerContent")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/simplifiedRegistration/brandPartnerContent
 */
export var useGetTenantApplicationsSimplifiedRegistrationBrandPartnerContent = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetTenantApplicationsSimplifiedRegistrationBrandPartnerContentKey(tenant, params)
            : null;
    });
    var swrFn = function () {
        return getTenantApplicationsSimplifiedRegistrationBrandPartnerContent(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Content for VIP customer's simplified registration application
 * @summary tenants/{tenant}/applications/simplifiedRegistration/vipCustomerContent
 */
export var getTenantApplicationsSimplifiedRegistrationVipCustomerContent = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/simplifiedRegistration/vipCustomerContent"),
        method: 'get',
        params: params,
    }, options);
};
export var getGetTenantApplicationsSimplifiedRegistrationVipCustomerContentKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/simplifiedRegistration/vipCustomerContent")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/simplifiedRegistration/vipCustomerContent
 */
export var useGetTenantApplicationsSimplifiedRegistrationVipCustomerContent = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetTenantApplicationsSimplifiedRegistrationVipCustomerContentKey(tenant, params)
            : null;
    });
    var swrFn = function () {
        return getTenantApplicationsSimplifiedRegistrationVipCustomerContent(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets smart app banner data.
 * @summary tenants/{tenant}/mobileApps/{platform}/smartAppBanner
 */
export var getTenantMobileAppSmartAppBanner = function (client, tenant, platform, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/mobileApps/").concat(platform, "/smartAppBanner"), method: 'get', params: params }, options);
};
export var getGetTenantMobileAppSmartAppBannerKey = function (tenant, platform, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/mobileApps/").concat(platform, "/smartAppBanner")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/mobileApps/{platform}/smartAppBanner
 */
export var useGetTenantMobileAppSmartAppBanner = function (tenant, platform, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(tenant && platform);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantMobileAppSmartAppBannerKey(tenant, platform, params) : null); });
    var swrFn = function () {
        return getTenantMobileAppSmartAppBanner(customInstance, tenant, platform, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET - Returns collection of Social Media Links.
 * @summary tenants/{tenant}/socialMediaLinks
 */
export var getTenantSocialMediaLinks = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/socialMediaLinks"), method: 'get', params: params }, options);
};
export var getGetTenantSocialMediaLinksKey = function (tenant, params) { return __spreadArray(["/tenants/".concat(tenant, "/socialMediaLinks")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/socialMediaLinks
 */
export var useGetTenantSocialMediaLinks = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantSocialMediaLinksKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantSocialMediaLinks(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Returns metadata about sponsor details of registration with given ID
 * @summary tenants/{tenant}/customerRegistrationsMetadata/{registrationType}/sponsorDetailsMetadata
 */
export var getTenantCustomerRegistrationsMetadatumSponsorDetailsMetadata = function (client, tenant, registrationType, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/customerRegistrationsMetadata/").concat(registrationType, "/sponsorDetailsMetadata"),
        method: 'get',
    }, options);
};
export var getGetTenantCustomerRegistrationsMetadatumSponsorDetailsMetadataKey = function (tenant, registrationType) {
    return [
        "/tenants/".concat(tenant, "/customerRegistrationsMetadata/").concat(registrationType, "/sponsorDetailsMetadata"),
    ];
};
/**
 * @summary tenants/{tenant}/customerRegistrationsMetadata/{registrationType}/sponsorDetailsMetadata
 */
export var useGetTenantCustomerRegistrationsMetadatumSponsorDetailsMetadata = function (tenant, registrationType, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(tenant && registrationType);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetTenantCustomerRegistrationsMetadatumSponsorDetailsMetadataKey(tenant, registrationType)
            : null;
    });
    var swrFn = function () {
        return getTenantCustomerRegistrationsMetadatumSponsorDetailsMetadata(customInstance, tenant, registrationType, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * @summary tenants/{tenant}/stepsToSuccessPhases
 */
export var getTenantStepsToSuccessPhases = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/stepsToSuccessPhases"), method: 'get', params: params }, options);
};
export var getGetTenantStepsToSuccessPhasesKey = function (tenant, params) { return __spreadArray(["/tenants/".concat(tenant, "/stepsToSuccessPhases")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/stepsToSuccessPhases
 */
export var useGetTenantStepsToSuccessPhases = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantStepsToSuccessPhasesKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantStepsToSuccessPhases(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get Steps to success localization
 * @summary tenants/{tenant}/applications/stepsToSuccess/localization
 */
export var getTenantApplicationsStepsToSuccessLocalization = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/stepsToSuccess/localization"), method: 'get', params: params }, options);
};
export var getGetTenantApplicationsStepsToSuccessLocalizationKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/stepsToSuccess/localization")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/stepsToSuccess/localization
 */
export var useGetTenantApplicationsStepsToSuccessLocalization = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetTenantApplicationsStepsToSuccessLocalizationKey(tenant, params) : null;
    });
    var swrFn = function () {
        return getTenantApplicationsStepsToSuccessLocalization(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Returns all existing subscription types and their packages, including inactive ones.
 * @summary tenants/{tenant}/subscriptionTypes
 */
export var getTenantSubscriptionTypes = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/subscriptionTypes"), method: 'get' }, options);
};
export var getGetTenantSubscriptionTypesKey = function (tenant) {
    return ["/tenants/".concat(tenant, "/subscriptionTypes")];
};
/**
 * @summary tenants/{tenant}/subscriptionTypes
 */
export var useGetTenantSubscriptionTypes = function (tenant, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantSubscriptionTypesKey(tenant) : null); });
    var swrFn = function () {
        return getTenantSubscriptionTypes(customInstance, tenant, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets benefit banners for products
 * @summary tenants/{tenant}/applications/banner/subscriptionBenefitBanners
 */
export var getTenantApplicationsBannerSubscriptionBenefitBanners = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/banner/subscriptionBenefitBanners"),
        method: 'get',
        params: params,
    }, options);
};
export var getGetTenantApplicationsBannerSubscriptionBenefitBannersKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/banner/subscriptionBenefitBanners")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/banner/subscriptionBenefitBanners
 */
export var useGetTenantApplicationsBannerSubscriptionBenefitBanners = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetTenantApplicationsBannerSubscriptionBenefitBannersKey(tenant, params)
            : null;
    });
    var swrFn = function () {
        return getTenantApplicationsBannerSubscriptionBenefitBanners(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * @summary tenants/{tenant}/subscriptionReplacements
 */
export var getTenantSubscriptionReplacements = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/subscriptionReplacements"), method: 'get', params: params }, options);
};
export var getGetTenantSubscriptionReplacementsKey = function (tenant, params) { return __spreadArray(["/tenants/".concat(tenant, "/subscriptionReplacements")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/subscriptionReplacements
 */
export var useGetTenantSubscriptionReplacements = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantSubscriptionReplacementsKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantSubscriptionReplacements(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Localization for SubscriptionWizard application
 * @summary tenants/{tenant}/applications/subscriptionWizard/localization
 */
export var getTenantApplicationsSubscriptionWizardLocalization = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/tenants/".concat(tenant, "/applications/subscriptionWizard/localization"),
        method: 'get',
        params: params,
    }, options);
};
export var getGetTenantApplicationsSubscriptionWizardLocalizationKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/subscriptionWizard/localization")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/subscriptionWizard/localization
 */
export var useGetTenantApplicationsSubscriptionWizardLocalization = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetTenantApplicationsSubscriptionWizardLocalizationKey(tenant, params) : null;
    });
    var swrFn = function () {
        return getTenantApplicationsSubscriptionWizardLocalization(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets the localization.
 * @summary applications/supportCenter/tenants/{tenant}/localization
 */
export var getApplicationsSupportCenterTenantLocalization = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/supportCenter/tenants/".concat(tenant, "/localization"), method: 'get', params: params }, options);
};
export var getGetApplicationsSupportCenterTenantLocalizationKey = function (tenant, params) {
    return __spreadArray([
        "/applications/supportCenter/tenants/".concat(tenant, "/localization")
    ], (params ? [params] : []), true);
};
/**
 * @summary applications/supportCenter/tenants/{tenant}/localization
 */
export var useGetApplicationsSupportCenterTenantLocalization = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetApplicationsSupportCenterTenantLocalizationKey(tenant, params) : null;
    });
    var swrFn = function () {
        return getApplicationsSupportCenterTenantLocalization(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * gets tag groups
 * @summary tenants/{tenant}/tagGroups
 */
export var getTenantTagGroups = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/tagGroups"), method: 'get', params: params }, options);
};
export var getGetTenantTagGroupsKey = function (tenant, params) {
    return __spreadArray(["/tenants/".concat(tenant, "/tagGroups")], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/tagGroups
 */
export var useGetTenantTagGroups = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantTagGroupsKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantTagGroups(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get target list localization
 * @summary targetList/tenants/{tenant}/localization
 */
export var getTargetListTenantLocalization = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/targetList/tenants/".concat(tenant, "/localization"), method: 'get', params: params }, options);
};
export var getGetTargetListTenantLocalizationKey = function (tenant, params) { return __spreadArray(["/targetList/tenants/".concat(tenant, "/localization")], (params ? [params] : []), true); };
/**
 * @summary targetList/tenants/{tenant}/localization
 */
export var useGetTargetListTenantLocalization = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTargetListTenantLocalizationKey(tenant, params) : null); });
    var swrFn = function () {
        return getTargetListTenantLocalization(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Returns terms info and html content
 * @summary tenants/{tenant}/terms/{termId}/html
 */
export var getTenantTermHtml = function (client, tenant, termId, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/terms/").concat(termId, "/html"), method: 'get' }, options);
};
export var getGetTenantTermHtmlKey = function (tenant, termId) {
    return ["/tenants/".concat(tenant, "/terms/").concat(termId, "/html")];
};
/**
 * @summary tenants/{tenant}/terms/{termId}/html
 */
export var useGetTenantTermHtml = function (tenant, termId, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(tenant && termId);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantTermHtmlKey(tenant, termId) : null); });
    var swrFn = function () {
        return getTenantTermHtml(customInstance, tenant, termId, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Ping
 * @summary test/tenants/{tenant}/ping
 */
export var getTestTenantPing = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/test/tenants/".concat(tenant, "/ping"), method: 'get' }, options);
};
export var getGetTestTenantPingKey = function (tenant) {
    return ["/test/tenants/".concat(tenant, "/ping")];
};
/**
 * @summary test/tenants/{tenant}/ping
 */
export var useGetTestTenantPing = function (tenant, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTestTenantPingKey(tenant) : null); });
    var swrFn = function () { return getTestTenantPing(customInstance, tenant, requestOptions).then(function (d) { return d.data; }); };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Ping with proxy to itself
 * @summary test/tenants/{tenant}/pingproxy
 */
export var getTestTenantPingproxy = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/test/tenants/".concat(tenant, "/pingproxy"), method: 'get' }, options);
};
export var getGetTestTenantPingproxyKey = function (tenant) {
    return ["/test/tenants/".concat(tenant, "/pingproxy")];
};
/**
 * @summary test/tenants/{tenant}/pingproxy
 */
export var useGetTestTenantPingproxy = function (tenant, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTestTenantPingproxyKey(tenant) : null); });
    var swrFn = function () {
        return getTestTenantPingproxy(customInstance, tenant, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET - returns TestFreaks configuration
 * @summary tenants/{tenant}/testfreaks/configuration
 */
export var getTenantTestfreaksConfiguration = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/testfreaks/configuration"), method: 'get', params: params }, options);
};
export var getGetTenantTestfreaksConfigurationKey = function (tenant, params) { return __spreadArray(["/tenants/".concat(tenant, "/testfreaks/configuration")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/testfreaks/configuration
 */
export var useGetTenantTestfreaksConfiguration = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantTestfreaksConfigurationKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantTestfreaksConfiguration(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get GTM, Google Analytics and OneTrust configuration
 * @summary tenants/{tenant}/thirdPartyConfiguration
 */
export var getTenantThirdPartyConfiguration = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/thirdPartyConfiguration"), method: 'get', params: params }, options);
};
export var getGetTenantThirdPartyConfigurationKey = function (tenant, params) { return __spreadArray(["/tenants/".concat(tenant, "/thirdPartyConfiguration")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/thirdPartyConfiguration
 */
export var useGetTenantThirdPartyConfiguration = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantThirdPartyConfigurationKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantThirdPartyConfiguration(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get title progress localization
 * @summary titleProgress/tenants/{tenant}/localization
 */
export var getTitleProgressTenantLocalization = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/titleProgress/tenants/".concat(tenant, "/localization"), method: 'get', params: params }, options);
};
export var getGetTitleProgressTenantLocalizationKey = function (tenant, params) { return __spreadArray(["/titleProgress/tenants/".concat(tenant, "/localization")], (params ? [params] : []), true); };
/**
 * @summary titleProgress/tenants/{tenant}/localization
 */
export var useGetTitleProgressTenantLocalization = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTitleProgressTenantLocalizationKey(tenant, params) : null); });
    var swrFn = function () {
        return getTitleProgressTenantLocalization(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET - provides tenant translations
 * @deprecated
 * @summary tenants/{tenant}/translations
 */
export var getTenantTranslationsDeprecated = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/translations"), method: 'get', params: params }, options);
};
export var getGetTenantTranslationsDeprecatedKey = function (tenant, params) { return __spreadArray(["/tenants/".concat(tenant, "/translations")], (params ? [params] : []), true); };
/**
 * @deprecated
 * @summary tenants/{tenant}/translations
 */
export var useGetTenantTranslationsDeprecated = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantTranslationsDeprecatedKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantTranslationsDeprecated(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET - provides Vip Customer Banner content.
 * @summary tenants/{tenant}/vipCustomerBanner
 */
export var getTenantVipCustomerBanner = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/vipCustomerBanner"), method: 'get', params: params }, options);
};
export var getGetTenantVipCustomerBannerKey = function (tenant, params) { return __spreadArray(["/tenants/".concat(tenant, "/vipCustomerBanner")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/vipCustomerBanner
 */
export var useGetTenantVipCustomerBanner = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantVipCustomerBannerKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantVipCustomerBanner(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Localization for VipUpgrade application
 * @summary tenants/{tenant}/applications/vipUpgrade/localization
 */
export var getTenantApplicationsVipUpgradeLocalization = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/vipUpgrade/localization"), method: 'get' }, options);
};
export var getGetTenantApplicationsVipUpgradeLocalizationKey = function (tenant) {
    return ["/tenants/".concat(tenant, "/applications/vipUpgrade/localization")];
};
/**
 * @summary tenants/{tenant}/applications/vipUpgrade/localization
 */
export var useGetTenantApplicationsVipUpgradeLocalization = function (tenant, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantApplicationsVipUpgradeLocalizationKey(tenant) : null); });
    var swrFn = function () {
        return getTenantApplicationsVipUpgradeLocalization(customInstance, tenant, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Content for VipUpgrade application
 * @summary tenants/{tenant}/applications/vipUpgrade/content
 */
export var getTenantApplicationsVipUpgradeContent = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/vipUpgrade/content"), method: 'get', params: params }, options);
};
export var getGetTenantApplicationsVipUpgradeContentKey = function (tenant, params) { return __spreadArray(["/tenants/".concat(tenant, "/applications/vipUpgrade/content")], (params ? [params] : []), true); };
/**
 * @summary tenants/{tenant}/applications/vipUpgrade/content
 */
export var useGetTenantApplicationsVipUpgradeContent = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantApplicationsVipUpgradeContentKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantApplicationsVipUpgradeContent(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Localization for Vouchers application
 * @summary tenants/{tenant}/applications/vouchers/localization
 */
export var getTenantApplicationsVouchersLocalization = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/vouchers/localization"), method: 'get', params: params }, options);
};
export var getGetTenantApplicationsVouchersLocalizationKey = function (tenant, params) {
    return __spreadArray(["/tenants/".concat(tenant, "/applications/vouchers/localization")], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/vouchers/localization
 */
export var useGetTenantApplicationsVouchersLocalization = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantApplicationsVouchersLocalizationKey(tenant, params) : null); });
    var swrFn = function () {
        return getTenantApplicationsVouchersLocalization(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Localization for Wallet application
 * @summary tenants/{tenant}/applications/wallet/localization
 */
export var getTenantApplicationsWalletLocalization = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/wallet/localization"), method: 'get' }, options);
};
export var getGetTenantApplicationsWalletLocalizationKey = function (tenant) {
    return ["/tenants/".concat(tenant, "/applications/wallet/localization")];
};
/**
 * @summary tenants/{tenant}/applications/wallet/localization
 */
export var useGetTenantApplicationsWalletLocalization = function (tenant, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantApplicationsWalletLocalizationKey(tenant) : null); });
    var swrFn = function () {
        return getTenantApplicationsWalletLocalization(customInstance, tenant, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Returns Web Messaging configuration
 * @summary tenants/{tenant}/applications/webMessenger/configuration
 */
export var getTenantApplicationsWebMessengerConfiguration = function (client, tenant, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/webMessenger/configuration"), method: 'get', params: params }, options);
};
export var getGetTenantApplicationsWebMessengerConfigurationKey = function (tenant, params) {
    return __spreadArray([
        "/tenants/".concat(tenant, "/applications/webMessenger/configuration")
    ], (params ? [params] : []), true);
};
/**
 * @summary tenants/{tenant}/applications/webMessenger/configuration
 */
export var useGetTenantApplicationsWebMessengerConfiguration = function (tenant, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetTenantApplicationsWebMessengerConfigurationKey(tenant, params) : null;
    });
    var swrFn = function () {
        return getTenantApplicationsWebMessengerConfiguration(customInstance, tenant, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get wellnes club static image banners
 * @summary tenants/{tenant}/applications/WellnessClub/banners
 */
export var getTenantApplicationsWellnessClubBanners = function (client, tenant, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tenants/".concat(tenant, "/applications/WellnessClub/banners"), method: 'get' }, options);
};
export var getGetTenantApplicationsWellnessClubBannersKey = function (tenant) {
    return ["/tenants/".concat(tenant, "/applications/WellnessClub/banners")];
};
/**
 * @summary tenants/{tenant}/applications/WellnessClub/banners
 */
export var useGetTenantApplicationsWellnessClubBanners = function (tenant, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!tenant;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTenantApplicationsWellnessClubBannersKey(tenant) : null); });
    var swrFn = function () {
        return getTenantApplicationsWellnessClubBanners(customInstance, tenant, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};

